/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onUpdatePlannerStatus = /* GraphQL */ `
  subscription OnUpdatePlannerStatus($id: ID) {
    onUpdatePlannerStatus(id: $id) {
      id
      isAIReplying
      activeMessageForAI
    }
  }
`;
export const onUpdateDocumentEmbeddingStatus = /* GraphQL */ `
  subscription OnUpdateDocumentEmbeddingStatus($id: String) {
    onUpdateDocumentEmbeddingStatus(id: $id) {
      id
      embedding_status
      completion_percentage
    }
  }
`;
export const onUpdateChatMessageByChatIDEvent = /* GraphQL */ `
  subscription OnUpdateChatMessageByChatIDEvent($chatID: ID) {
    onUpdateChatMessageByChatIDEvent(chatID: $chatID) {
      id
      role
      chatID
      text
      t_text
      t_text_summary
      createdAt
      creationTime
      updatedAt
      scoring
      embeddingId
      humanFeedback
      humanFeedbackComment
      humanFeedbackType
      humanFeedbackSubType
      humanFeedbackProvidedBy
      adminResolution
      prevMessage
      prevMessagePosEq
      prevMessageNegEq
      correctContext
      correctAnswer
      adminChecked
      autoTune
      userID
      agentID
      humanFeedbackForInstruction
      images
      audios
      videos
      files
      imagesText
      audiosText
      videosText
      filesText
      isAI
      messageType
      status
      metadata
      callbackMetadata
      workspaceID
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onCreateChatMessageByChatIDEvent = /* GraphQL */ `
  subscription OnCreateChatMessageByChatIDEvent($chatID: ID) {
    onCreateChatMessageByChatIDEvent(chatID: $chatID) {
      id
      role
      chatID
      text
      t_text
      t_text_summary
      createdAt
      creationTime
      updatedAt
      scoring
      embeddingId
      humanFeedback
      humanFeedbackComment
      humanFeedbackType
      humanFeedbackSubType
      humanFeedbackProvidedBy
      adminResolution
      prevMessage
      prevMessagePosEq
      prevMessageNegEq
      correctContext
      correctAnswer
      adminChecked
      autoTune
      userID
      agentID
      humanFeedbackForInstruction
      images
      audios
      videos
      files
      imagesText
      audiosText
      videosText
      filesText
      isAI
      messageType
      status
      metadata
      callbackMetadata
      workspaceID
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onDeleteChatMessageByChatIDEvent = /* GraphQL */ `
  subscription OnDeleteChatMessageByChatIDEvent($chatID: ID) {
    onDeleteChatMessageByChatIDEvent(chatID: $chatID) {
      id
      role
      chatID
      text
      t_text
      t_text_summary
      createdAt
      creationTime
      updatedAt
      scoring
      embeddingId
      humanFeedback
      humanFeedbackComment
      humanFeedbackType
      humanFeedbackSubType
      humanFeedbackProvidedBy
      adminResolution
      prevMessage
      prevMessagePosEq
      prevMessageNegEq
      correctContext
      correctAnswer
      adminChecked
      autoTune
      userID
      agentID
      humanFeedbackForInstruction
      images
      audios
      videos
      files
      imagesText
      audiosText
      videosText
      filesText
      isAI
      messageType
      status
      metadata
      callbackMetadata
      workspaceID
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onUpdateChatMessageEvent = /* GraphQL */ `
  subscription OnUpdateChatMessageEvent($id: ID) {
    onUpdateChatMessageEvent(id: $id) {
      id
      role
      chatID
      text
      t_text
      t_text_summary
      createdAt
      creationTime
      updatedAt
      scoring
      embeddingId
      humanFeedback
      humanFeedbackComment
      humanFeedbackType
      humanFeedbackSubType
      humanFeedbackProvidedBy
      adminResolution
      prevMessage
      prevMessagePosEq
      prevMessageNegEq
      correctContext
      correctAnswer
      adminChecked
      autoTune
      userID
      agentID
      humanFeedbackForInstruction
      images
      audios
      videos
      files
      imagesText
      audiosText
      videosText
      filesText
      isAI
      messageType
      status
      metadata
      callbackMetadata
      workspaceID
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onUpdateOutputStreamByIDEvent = /* GraphQL */ `
  subscription OnUpdateOutputStreamByIDEvent($id: ID) {
    onUpdateOutputStreamByIDEvent(id: $id) {
      id
      content
      t_content
      prompt
      t_prompt
      workspaceID
      type
      status
      humanFeedback
      humanFeedbackComment
      humanFeedbackType
      humanFeedbackSubType
      humanFeedbackProvidedBy
      adminResolution
      adminChecked
      autoTune
      scoring
      metadata
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onCreateUserEvent = /* GraphQL */ `
  subscription OnCreateUserEvent($owner: String) {
    onCreateUserEvent(owner: $owner) {
      id
      owner
      username
      user_email
      user_email_verified
      user_phone_number
      timezone
      language
      isSentenceSplitEnabled
      isImplicitSelfEnabled
      replyLanguage
      theme
      user_phone_number_verified
      userInstructions
      userMemories
      isOnboarded
      userHelperPreferences
      type
      workspaces {
        items {
          id
          owner
          title
          visibility
          userID
          isMed
          type
          usagePlanID
          workspaceTokenID
          workspaceToken
          subscriptionType
          subscriptionId
          subscriptionStatus
          enableExperimentalFeatures
          utilityEndpoint
          utilityUrl
          utilityUrlStatus
          utilityUrlType
          utilityBaseModel
          utilityProvider
          codingEndpoint
          codingUrl
          codingUrlStatus
          codingUrlType
          codingBaseModel
          codingProvider
          generalPurposeEndpoint
          generalPurposeUrl
          generalPurposeUrlStatus
          generalPurposeUrlType
          generalPurposeBaseModel
          generalPurposeProvider
          qaEnpoint
          qaUrl
          qaUrlStatus
          qaUrlType
          qaBaseModel
          qaProvider
          cnEndpoint
          cnUrl
          cnUrlStatus
          cnUrlType
          cnBaseModel
          cnProvider
          gnEnpoint
          gnUrl
          gnUrlStatus
          gnUrlType
          gnBaseModel
          gnProvider
          nlpEnpoint
          nlpUrl
          nlpUrlStatus
          nlpUrlType
          nlpBaseModel
          nlpProvider
          embeddingEndpoint
          embeddingUrl
          embeddingUrlStatus
          embeddingUrlType
          embeddingBaseModel
          embeddingProvider
          chartingEndpoint
          chartingUrl
          chartingUrlStatus
          chartingUrlType
          chartingBaseModel
          chartingProvider
          imagingEndpoint
          imagingUrl
          imagingUrlStatus
          imagingUrlType
          imagingBaseModel
          imagingProvider
          reasoningEndpoint
          reasoningUrl
          reasoningUrlStatus
          reasoningUrlType
          reasoningBaseModel
          reasoningProvider
          billingStatus
          lastBillingDate
          lastConsumptionNotificationDate
          activeUntil
          paymentFailed
          bulkImportAllowed
          lastPaymentAttempt
          targetSubscriptionType
          lastChangeSubscriptionDate
          maxUsers
          baseModel
          domain
          customImageRecognitionModel
          customVectorDB
          disabled
          users
          workspaceCreationDate
          workspaceModelReady
          enableDeleteFunctionInAgents
          enableUpdateFunctionInAgents
          enableCustomFunctionInAgents
          defaultChatAgent
          defaultBusinessAnalystAgent
          defaultContentCreatorAgent
          isSentimentReviewerEnabled
          isExtendedContentCreatorEnabled
          isExtendedBusinessAnalystReportEnabled
          customIndexedDBendpoint
          createdBy
          updatedBy
          federationMetadataUrl
          federationMetadataUrlStatus
          federationMetadataUrlType
          ssoType
          ssoDomain
          ssoProviderName
          isMultiLanguageEnabled
          customChartingConfig
          twilioConfig
          emailConfig
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      cognitoUsername
      stripeCustomerId
      subscribedToNewsletter
      isLead
      stripePaymentIntentId
      maximumNumberOfWorkspaces
      workspacesAccessLevel {
        items {
          id
          workspaceID
          userID
          userType
          policyID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onUpdateUserEvent = /* GraphQL */ `
  subscription OnUpdateUserEvent($owner: String) {
    onUpdateUserEvent(owner: $owner) {
      id
      owner
      username
      user_email
      user_email_verified
      user_phone_number
      timezone
      language
      isSentenceSplitEnabled
      isImplicitSelfEnabled
      replyLanguage
      theme
      user_phone_number_verified
      userInstructions
      userMemories
      isOnboarded
      userHelperPreferences
      type
      workspaces {
        items {
          id
          owner
          title
          visibility
          userID
          isMed
          type
          usagePlanID
          workspaceTokenID
          workspaceToken
          subscriptionType
          subscriptionId
          subscriptionStatus
          enableExperimentalFeatures
          utilityEndpoint
          utilityUrl
          utilityUrlStatus
          utilityUrlType
          utilityBaseModel
          utilityProvider
          codingEndpoint
          codingUrl
          codingUrlStatus
          codingUrlType
          codingBaseModel
          codingProvider
          generalPurposeEndpoint
          generalPurposeUrl
          generalPurposeUrlStatus
          generalPurposeUrlType
          generalPurposeBaseModel
          generalPurposeProvider
          qaEnpoint
          qaUrl
          qaUrlStatus
          qaUrlType
          qaBaseModel
          qaProvider
          cnEndpoint
          cnUrl
          cnUrlStatus
          cnUrlType
          cnBaseModel
          cnProvider
          gnEnpoint
          gnUrl
          gnUrlStatus
          gnUrlType
          gnBaseModel
          gnProvider
          nlpEnpoint
          nlpUrl
          nlpUrlStatus
          nlpUrlType
          nlpBaseModel
          nlpProvider
          embeddingEndpoint
          embeddingUrl
          embeddingUrlStatus
          embeddingUrlType
          embeddingBaseModel
          embeddingProvider
          chartingEndpoint
          chartingUrl
          chartingUrlStatus
          chartingUrlType
          chartingBaseModel
          chartingProvider
          imagingEndpoint
          imagingUrl
          imagingUrlStatus
          imagingUrlType
          imagingBaseModel
          imagingProvider
          reasoningEndpoint
          reasoningUrl
          reasoningUrlStatus
          reasoningUrlType
          reasoningBaseModel
          reasoningProvider
          billingStatus
          lastBillingDate
          lastConsumptionNotificationDate
          activeUntil
          paymentFailed
          bulkImportAllowed
          lastPaymentAttempt
          targetSubscriptionType
          lastChangeSubscriptionDate
          maxUsers
          baseModel
          domain
          customImageRecognitionModel
          customVectorDB
          disabled
          users
          workspaceCreationDate
          workspaceModelReady
          enableDeleteFunctionInAgents
          enableUpdateFunctionInAgents
          enableCustomFunctionInAgents
          defaultChatAgent
          defaultBusinessAnalystAgent
          defaultContentCreatorAgent
          isSentimentReviewerEnabled
          isExtendedContentCreatorEnabled
          isExtendedBusinessAnalystReportEnabled
          customIndexedDBendpoint
          createdBy
          updatedBy
          federationMetadataUrl
          federationMetadataUrlStatus
          federationMetadataUrlType
          ssoType
          ssoDomain
          ssoProviderName
          isMultiLanguageEnabled
          customChartingConfig
          twilioConfig
          emailConfig
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      cognitoUsername
      stripeCustomerId
      subscribedToNewsletter
      isLead
      stripePaymentIntentId
      maximumNumberOfWorkspaces
      workspacesAccessLevel {
        items {
          id
          workspaceID
          userID
          userType
          policyID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onDeleteUserEvent = /* GraphQL */ `
  subscription OnDeleteUserEvent($owner: String) {
    onDeleteUserEvent(owner: $owner) {
      id
      owner
      username
      user_email
      user_email_verified
      user_phone_number
      timezone
      language
      isSentenceSplitEnabled
      isImplicitSelfEnabled
      replyLanguage
      theme
      user_phone_number_verified
      userInstructions
      userMemories
      isOnboarded
      userHelperPreferences
      type
      workspaces {
        items {
          id
          owner
          title
          visibility
          userID
          isMed
          type
          usagePlanID
          workspaceTokenID
          workspaceToken
          subscriptionType
          subscriptionId
          subscriptionStatus
          enableExperimentalFeatures
          utilityEndpoint
          utilityUrl
          utilityUrlStatus
          utilityUrlType
          utilityBaseModel
          utilityProvider
          codingEndpoint
          codingUrl
          codingUrlStatus
          codingUrlType
          codingBaseModel
          codingProvider
          generalPurposeEndpoint
          generalPurposeUrl
          generalPurposeUrlStatus
          generalPurposeUrlType
          generalPurposeBaseModel
          generalPurposeProvider
          qaEnpoint
          qaUrl
          qaUrlStatus
          qaUrlType
          qaBaseModel
          qaProvider
          cnEndpoint
          cnUrl
          cnUrlStatus
          cnUrlType
          cnBaseModel
          cnProvider
          gnEnpoint
          gnUrl
          gnUrlStatus
          gnUrlType
          gnBaseModel
          gnProvider
          nlpEnpoint
          nlpUrl
          nlpUrlStatus
          nlpUrlType
          nlpBaseModel
          nlpProvider
          embeddingEndpoint
          embeddingUrl
          embeddingUrlStatus
          embeddingUrlType
          embeddingBaseModel
          embeddingProvider
          chartingEndpoint
          chartingUrl
          chartingUrlStatus
          chartingUrlType
          chartingBaseModel
          chartingProvider
          imagingEndpoint
          imagingUrl
          imagingUrlStatus
          imagingUrlType
          imagingBaseModel
          imagingProvider
          reasoningEndpoint
          reasoningUrl
          reasoningUrlStatus
          reasoningUrlType
          reasoningBaseModel
          reasoningProvider
          billingStatus
          lastBillingDate
          lastConsumptionNotificationDate
          activeUntil
          paymentFailed
          bulkImportAllowed
          lastPaymentAttempt
          targetSubscriptionType
          lastChangeSubscriptionDate
          maxUsers
          baseModel
          domain
          customImageRecognitionModel
          customVectorDB
          disabled
          users
          workspaceCreationDate
          workspaceModelReady
          enableDeleteFunctionInAgents
          enableUpdateFunctionInAgents
          enableCustomFunctionInAgents
          defaultChatAgent
          defaultBusinessAnalystAgent
          defaultContentCreatorAgent
          isSentimentReviewerEnabled
          isExtendedContentCreatorEnabled
          isExtendedBusinessAnalystReportEnabled
          customIndexedDBendpoint
          createdBy
          updatedBy
          federationMetadataUrl
          federationMetadataUrlStatus
          federationMetadataUrlType
          ssoType
          ssoDomain
          ssoProviderName
          isMultiLanguageEnabled
          customChartingConfig
          twilioConfig
          emailConfig
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      cognitoUsername
      stripeCustomerId
      subscribedToNewsletter
      isLead
      stripePaymentIntentId
      maximumNumberOfWorkspaces
      workspacesAccessLevel {
        items {
          id
          workspaceID
          userID
          userType
          policyID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onCreateWorkspaceEvent = /* GraphQL */ `
  subscription OnCreateWorkspaceEvent($owner: String) {
    onCreateWorkspaceEvent(owner: $owner) {
      id
      owner
      title
      visibility
      userID
      isMed
      type
      usagePlanID
      workspaceTokenID
      workspaceToken
      subscriptionType
      subscriptionId
      subscriptionStatus
      enableExperimentalFeatures
      utilityEndpoint
      utilityUrl
      utilityUrlStatus
      utilityUrlType
      utilityBaseModel
      utilityProvider
      codingEndpoint
      codingUrl
      codingUrlStatus
      codingUrlType
      codingBaseModel
      codingProvider
      generalPurposeEndpoint
      generalPurposeUrl
      generalPurposeUrlStatus
      generalPurposeUrlType
      generalPurposeBaseModel
      generalPurposeProvider
      qaEnpoint
      qaUrl
      qaUrlStatus
      qaUrlType
      qaBaseModel
      qaProvider
      cnEndpoint
      cnUrl
      cnUrlStatus
      cnUrlType
      cnBaseModel
      cnProvider
      gnEnpoint
      gnUrl
      gnUrlStatus
      gnUrlType
      gnBaseModel
      gnProvider
      nlpEnpoint
      nlpUrl
      nlpUrlStatus
      nlpUrlType
      nlpBaseModel
      nlpProvider
      embeddingEndpoint
      embeddingUrl
      embeddingUrlStatus
      embeddingUrlType
      embeddingBaseModel
      embeddingProvider
      chartingEndpoint
      chartingUrl
      chartingUrlStatus
      chartingUrlType
      chartingBaseModel
      chartingProvider
      imagingEndpoint
      imagingUrl
      imagingUrlStatus
      imagingUrlType
      imagingBaseModel
      imagingProvider
      reasoningEndpoint
      reasoningUrl
      reasoningUrlStatus
      reasoningUrlType
      reasoningBaseModel
      reasoningProvider
      billingStatus
      lastBillingDate
      lastConsumptionNotificationDate
      activeUntil
      paymentFailed
      bulkImportAllowed
      lastPaymentAttempt
      targetSubscriptionType
      lastChangeSubscriptionDate
      maxUsers
      baseModel
      domain
      trainingConfig {
        trainingIterations
        trainingIterationsNLP
        trainingIterationsRC
        trainingEpochsNLP
        trainingEpochsRC
        trainingEpochsGN
        maxStepsNLP
        patienceNLP
        learningRateNLP
        learningRateRC
        testSizeNLP
        testSizeRC
        batchSizeNLP
        batchSizeRC
        datasetTestSizeThresholdNLP
        datasetTestSizeThresholdRC
        learningRateGN
        testSizeGN
        batchSizeGN
        datasetTestSizeThresholdGN
        enableManagedSpotTraining
        maxRuntimeWaitTime
        maxRuntime
        includeReadComprehensionDataInTraining
        generateDockerImageForRCengine
        generateDockerImageForNLPengine
        generateDockerImageForGNengine
        emailsListForTrainingConfirmation
        maxQueueWaitTime
      }
      parsingConfig {
        questionsLimit
        answerAsNER
        answerByParagraph
        uniqueAnswer
        isSentenceSplitEnabled
        isImplicitSelfEnabled
        temperature
        maxTokens
        topP
        topK
        qaDocTopK
        frequencyPenalty
        presencePenalty
        qaTopP
        qaTopK
        qaMaxTokens
        qaTemperature
        qaFrequencyPenalty
        qaPresencePenalty
        qaReplyOutsidePassage
        qaAiKnowledge
        qaInhibitionPassage
        qaEnhancementPassage
        qaRole
        qaDefaultAnswer
        qaStopSequence
        stopSequence
        stopPrompt
        qaExamples {
          question
          answer
        }
        qaBlender
        agcEnabled
      }
      notificationConfig {
        emailsList
        emailOnTrainingCompleted
        emailOnBatchCompleted
        emailOnBatchFailed
        emailOnBatchStart
        emailOnTrainingFailed
        emailOnTrainingStart
        notifyAllUsersInWorkspace
        notifyOnThreasholdConsumption
        notificationThresholdConsumption
      }
      embeddingConfig {
        maxChunkWords
        maxOverlapSentences
        chunkingStrategy
        imageExtractionStrategy
        minImageWidth
        minImageHeight
        aspectRatioMin
        aspectRatioMax
      }
      customGenerationConfig {
        styles
        domains
        scopes
        prompts {
          type
          label
          promptLength
          promptPlaceholder
          interpolationString
        }
        hasTopicsContext
        topics
        docTopK
        topK
        blender
        mode
        aiKnowledge
        compressor
      }
      customImageRecognitionModel
      customVectorDB
      workspaceAgents {
        items {
          id
          type
          label
          description
          interpolationString
          emoji
          color
          darkColor
          icon
          largeLogo
          icoUrl
          logoBackground
          darkLogoBackground
          messageOnLaunch
          messagesOnLaunch
          rotateMessagesOnLaunch
          rotateMessagesOnLaunchInterval
          placeholderMessageOnLoading
          customGreetingInstructions
          customConclusionInstructions
          customChartingInstructions
          customSummarisationInstructions
          customImagesInstructions
          customToolingInstructions
          placeholderInputMessage
          openByDefault
          disclaimer
          showDocumentsReferences
          isDefault
          hasMemory
          hasImages
          promptTopKeywords
          keyWordsForKnowledgeBase
          hasTopicsContext
          hasFunctions
          advancedLanguageDetection
          allowedTopics
          staticDocs
          defaultAnswer
          noKnowledgeDefaultAnswer
          quickQuestions
          recencyImportance
          maxRecencyIncrease
          recencyTopKIncreaseFactor
          stopSequence
          enhancementPassage
          inhibitionPassage
          pertinencePassage
          goals
          qaUrl
          topK
          mode
          showCodeInExecution
          hideReasoning
          charting
          summarisation
          compressor
          docTopK
          minRetrievalScore
          timeSignificance
          hasModeration
          customModerations
          moderationMessage
          languageDetectionConfidence
          maxHistory
          maxTokens
          topicEnhancer
          maxTopics
          blender
          temperature
          version
          subject
          workspaceID
          createdBy
          updatedBy
          agentFunctions
          isGlobal
          promptBuffering
          functionContext
          plainTextOutput
          chainOfThoughts
          treeOfThoughts
          extendedOutput
          agentType
          agentsPool
          mcps
          maxPlanningSteps
          virtualDesktopInstructions
          planningInstructions
          plannerExecutionAttempts
          plannerRequiresApprovalForPlanExecution
          plannerEmailOnApprovalRequest
          plannerEmailOnFailedPlan
          plannerEmailOnCompletedPlan
          plannerAutoAgentSpawn
          plannerRetainsSpawnedAgents
          plannerPromptsAgentsProgrammatically
          plannerDeepThinking
          allowReplanning
          plannerProceedsWhenImprovementsRequired
          plannerApproverEmails
          reviewInstructions
          showReferencesToInternalDocs
          preventWidgetUsage
          allowFeedback
          generateExtendedReport
          showTimeForResponse
          showDetectedLanguage
          showRoutedModel
          isMultiLanguageEnabled
          hasMath
          hasCode
          hasComputer
          hasNER
          restrictedAccess
          restrictedAccessUsers
          splashTitle
          showSplashWhenEmpty
          llmEndpoint
          llmUrl
          llmUrlStatus
          llmUrlType
          llmBaseModel
          llmProvider
          forcedTheme
          adverserialProvider
          adverserialModel
          functionCallingProvider
          functionCallingModel
          visionProvider
          visionModel
          videoGenerationProvider
          videoGenerationModel
          showAgentName
          allowImagesUpload
          allowVideosUpload
          allowAudiosUpload
          allowDocsUpload
          allowImagesGeneration
          baseImageGenerationModel
          maxImagesGenerated
          advancedImageGeneration
          allowVideosGeneration
          allowAudiosGeneration
          voiceFileKey
          allowInternetSearch
          bannedDomains
          maxUrlsForInternetSearch
          allowDeepInternetSearch
          internetSearchModes
          internetSearchLocation
          autoVoiceMode
          keywordsWeightInRetrieval
          customCodeExecutionEnvironments
          phoneNumberAsSender
          whatsappNumberAsSender
          emailAsSender
          communicationServices
          channelCallbackDelay
          ephemeralAgent
          parentAgentID
          parentChatID
          minimumSubscriptionType
          clonedAgentID
          clonedAgentIDIcon
          hasContentCreation
          hasEntityExtraction
          department
          metadata
          allowEmailToAgent
          allowedEmails
          agentHiringTemplate
          agentDesktopVM
          agentDesktopPortRange
          agentDesktopCredentials
          agentDesktopBrowser
          allow3dModelGeneration
          agentLongTermMemory
          isLongTermMemoryEnabled
          allowExternalAPI
          forceNewThreadOnProgrammaticRequest
          dynamicModelSelectionInstructions
          contextRelevancyRatio
          reasoningBudget
          reasoningMode
          agentFnParams
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      workspaceCustomPrompts {
        items {
          id
          type
          scope
          style
          domain
          label
          promptLength
          promptPlaceholder
          interpolationString
          availableToAgents
          workspaceID
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      customQaConfig {
        roles {
          type
          label
          description
          interpolationString
          emoji
          color
          isDefault
          hasMemory
          hasTopicsContext
          allowedTopics
          defaultAnswer
          stopSequence
          enhancementPassage
          inhibitionPassage
          pertinencePassage
          goals
          qaUrl
          topK
          mode
          charting
          summarisation
          compressor
          docTopK
          maxHistory
          maxTokens
          topicEnhancer
          maxTopics
          blender
          temperature
          version
          subject
        }
      }
      aiConsumption {
        generator {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        questioner {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        translator {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        answerer {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        parser {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        tokenizer {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        embedder {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        detector {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        chatter {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        planner {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        lastUpdate
        requestsLast30Minutes
        requestsLast24Hours
      }
      disabled
      subscriptionPricingPlan {
        items {
          id
          type
          subscriptionStatus
          isPredictionOnDemandGlobal
          isTrainingOnDemandGlobal
          predictionRequestsGlobal
          batchRequestsGlobal
          trainingMinutesGlobal
          baseModelGN
          baseModelQA
          baseModelNLP
          maxUsers
          agcEnabled
          isDownloadModelEnabled
          isDownloadDataEnabled
          isAPIAccessEnabled
          isBatchJobsEnabled
          isSentimentReviewerEnabled
          isBusinessAnalystEnabled
          isContentCreatorEnabled
          isPriorityTrainingEnabled
          isPredictionGPUAccelerationEnabledGlobal
          isPredictionGPUAccelerationEnabledRC
          isPredictionGPUAccelerationEnabledNLP
          maxMrcDocs
          maxAgents
          maxSites
          maxBenchmarks
          predictionRequestsAPI
          accuracyModelEnabled
          isTrainingNLPEnabled
          isTrainingQAEnabled
          isTrainingGNEnabled
          isLongTermMemoryEnabled
          isFunctionsEnabled
          isDBFunctionsEnabled
          isHtmlFunctionsEnabled
          isSitesBindingEnabled
          isAgentsSecurityEnabled
          isWidgetChatsHistoryEnabled
          maxRequests30Minutes
          maxRequests24Hours
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      folders {
        items {
          id
          owner
          name
          description
          emoji
          status
          parent
          workspaceID
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      trainingLogs {
        items {
          id
          owner
          name
          description
          status
          trainingIterations
          lastActivation
          duration
          trainingMeta
          trainingConfig
          workspaceID
          type
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      entities {
        items {
          id
          owner
          label
          type
          description
          emoji
          parentEntity
          backgroundColor
          workspaceID
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      appLogs {
        items {
          id
          owner
          type
          filename
          event
          status
          workspaceID
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      batchJobs {
        items {
          id
          owner
          name
          description
          status
          duration
          batchMeta
          batchConfig
          batchOutput
          workspaceID
          type
          createdBy
          updatedBy
          benchmarkID
          agentID
          agentVersion
          reviewerAgentID
          reviewerAgentVersion
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      dictionaryItems {
        items {
          id
          owner
          sourceLanguage
          targetLanguage
          sourceText
          targetText
          workspaceID
          pos
          description
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      requestsLogs {
        items {
          id
          srtKey
          type
          status
          words
          tokens
          sentences
          artifactsNumber
          modelType
          outputType
          agentID
          workspaceID
          createdBy
          updatedBy
          creationTime
          isFromToothFairy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      communicationServices {
        items {
          id
          workspaceID
          name
          description
          channel
          provider
          senderid
          fromNumber
          tokenSecret
          isActive
          config
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      sites {
        items {
          id
          name
          description
          url
          workspaceID
          topics
          status
          lastValidationDate
          lastValidationRequested
          validationToken
          allowedPaths
          siteTree
          lastScraped
          skipOwnerValidation
          useProxy
          completion_percentage
          extractImages
          freeRoaming
          scrapingCycle
          imgRetrievalPrompt
          metadata
          createdBy
          updatedBy
          scapablePages
          scrapedPagesCount
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      users
      usersAccessLevel {
        items {
          id
          workspaceID
          userID
          userType
          policyID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      workspaceCreationDate
      workspaceModelReady
      enableDeleteFunctionInAgents
      enableUpdateFunctionInAgents
      enableCustomFunctionInAgents
      defaultChatAgent
      defaultBusinessAnalystAgent
      defaultContentCreatorAgent
      isSentimentReviewerEnabled
      isExtendedContentCreatorEnabled
      isExtendedBusinessAnalystReportEnabled
      customIndexedDBendpoint
      createdBy
      updatedBy
      federationMetadataUrl
      federationMetadataUrlStatus
      federationMetadataUrlType
      ssoType
      ssoDomain
      ssoProviderName
      isMultiLanguageEnabled
      customChartingConfig
      twilioConfig
      emailConfig
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onUpdateWorkspaceEvent = /* GraphQL */ `
  subscription OnUpdateWorkspaceEvent($owner: String, $id: ID) {
    onUpdateWorkspaceEvent(owner: $owner, id: $id) {
      id
      owner
      title
      visibility
      userID
      isMed
      type
      usagePlanID
      workspaceTokenID
      workspaceToken
      subscriptionType
      subscriptionId
      subscriptionStatus
      enableExperimentalFeatures
      utilityEndpoint
      utilityUrl
      utilityUrlStatus
      utilityUrlType
      utilityBaseModel
      utilityProvider
      codingEndpoint
      codingUrl
      codingUrlStatus
      codingUrlType
      codingBaseModel
      codingProvider
      generalPurposeEndpoint
      generalPurposeUrl
      generalPurposeUrlStatus
      generalPurposeUrlType
      generalPurposeBaseModel
      generalPurposeProvider
      qaEnpoint
      qaUrl
      qaUrlStatus
      qaUrlType
      qaBaseModel
      qaProvider
      cnEndpoint
      cnUrl
      cnUrlStatus
      cnUrlType
      cnBaseModel
      cnProvider
      gnEnpoint
      gnUrl
      gnUrlStatus
      gnUrlType
      gnBaseModel
      gnProvider
      nlpEnpoint
      nlpUrl
      nlpUrlStatus
      nlpUrlType
      nlpBaseModel
      nlpProvider
      embeddingEndpoint
      embeddingUrl
      embeddingUrlStatus
      embeddingUrlType
      embeddingBaseModel
      embeddingProvider
      chartingEndpoint
      chartingUrl
      chartingUrlStatus
      chartingUrlType
      chartingBaseModel
      chartingProvider
      imagingEndpoint
      imagingUrl
      imagingUrlStatus
      imagingUrlType
      imagingBaseModel
      imagingProvider
      reasoningEndpoint
      reasoningUrl
      reasoningUrlStatus
      reasoningUrlType
      reasoningBaseModel
      reasoningProvider
      billingStatus
      lastBillingDate
      lastConsumptionNotificationDate
      activeUntil
      paymentFailed
      bulkImportAllowed
      lastPaymentAttempt
      targetSubscriptionType
      lastChangeSubscriptionDate
      maxUsers
      baseModel
      domain
      trainingConfig {
        trainingIterations
        trainingIterationsNLP
        trainingIterationsRC
        trainingEpochsNLP
        trainingEpochsRC
        trainingEpochsGN
        maxStepsNLP
        patienceNLP
        learningRateNLP
        learningRateRC
        testSizeNLP
        testSizeRC
        batchSizeNLP
        batchSizeRC
        datasetTestSizeThresholdNLP
        datasetTestSizeThresholdRC
        learningRateGN
        testSizeGN
        batchSizeGN
        datasetTestSizeThresholdGN
        enableManagedSpotTraining
        maxRuntimeWaitTime
        maxRuntime
        includeReadComprehensionDataInTraining
        generateDockerImageForRCengine
        generateDockerImageForNLPengine
        generateDockerImageForGNengine
        emailsListForTrainingConfirmation
        maxQueueWaitTime
      }
      parsingConfig {
        questionsLimit
        answerAsNER
        answerByParagraph
        uniqueAnswer
        isSentenceSplitEnabled
        isImplicitSelfEnabled
        temperature
        maxTokens
        topP
        topK
        qaDocTopK
        frequencyPenalty
        presencePenalty
        qaTopP
        qaTopK
        qaMaxTokens
        qaTemperature
        qaFrequencyPenalty
        qaPresencePenalty
        qaReplyOutsidePassage
        qaAiKnowledge
        qaInhibitionPassage
        qaEnhancementPassage
        qaRole
        qaDefaultAnswer
        qaStopSequence
        stopSequence
        stopPrompt
        qaExamples {
          question
          answer
        }
        qaBlender
        agcEnabled
      }
      notificationConfig {
        emailsList
        emailOnTrainingCompleted
        emailOnBatchCompleted
        emailOnBatchFailed
        emailOnBatchStart
        emailOnTrainingFailed
        emailOnTrainingStart
        notifyAllUsersInWorkspace
        notifyOnThreasholdConsumption
        notificationThresholdConsumption
      }
      embeddingConfig {
        maxChunkWords
        maxOverlapSentences
        chunkingStrategy
        imageExtractionStrategy
        minImageWidth
        minImageHeight
        aspectRatioMin
        aspectRatioMax
      }
      customGenerationConfig {
        styles
        domains
        scopes
        prompts {
          type
          label
          promptLength
          promptPlaceholder
          interpolationString
        }
        hasTopicsContext
        topics
        docTopK
        topK
        blender
        mode
        aiKnowledge
        compressor
      }
      customImageRecognitionModel
      customVectorDB
      workspaceAgents {
        items {
          id
          type
          label
          description
          interpolationString
          emoji
          color
          darkColor
          icon
          largeLogo
          icoUrl
          logoBackground
          darkLogoBackground
          messageOnLaunch
          messagesOnLaunch
          rotateMessagesOnLaunch
          rotateMessagesOnLaunchInterval
          placeholderMessageOnLoading
          customGreetingInstructions
          customConclusionInstructions
          customChartingInstructions
          customSummarisationInstructions
          customImagesInstructions
          customToolingInstructions
          placeholderInputMessage
          openByDefault
          disclaimer
          showDocumentsReferences
          isDefault
          hasMemory
          hasImages
          promptTopKeywords
          keyWordsForKnowledgeBase
          hasTopicsContext
          hasFunctions
          advancedLanguageDetection
          allowedTopics
          staticDocs
          defaultAnswer
          noKnowledgeDefaultAnswer
          quickQuestions
          recencyImportance
          maxRecencyIncrease
          recencyTopKIncreaseFactor
          stopSequence
          enhancementPassage
          inhibitionPassage
          pertinencePassage
          goals
          qaUrl
          topK
          mode
          showCodeInExecution
          hideReasoning
          charting
          summarisation
          compressor
          docTopK
          minRetrievalScore
          timeSignificance
          hasModeration
          customModerations
          moderationMessage
          languageDetectionConfidence
          maxHistory
          maxTokens
          topicEnhancer
          maxTopics
          blender
          temperature
          version
          subject
          workspaceID
          createdBy
          updatedBy
          agentFunctions
          isGlobal
          promptBuffering
          functionContext
          plainTextOutput
          chainOfThoughts
          treeOfThoughts
          extendedOutput
          agentType
          agentsPool
          mcps
          maxPlanningSteps
          virtualDesktopInstructions
          planningInstructions
          plannerExecutionAttempts
          plannerRequiresApprovalForPlanExecution
          plannerEmailOnApprovalRequest
          plannerEmailOnFailedPlan
          plannerEmailOnCompletedPlan
          plannerAutoAgentSpawn
          plannerRetainsSpawnedAgents
          plannerPromptsAgentsProgrammatically
          plannerDeepThinking
          allowReplanning
          plannerProceedsWhenImprovementsRequired
          plannerApproverEmails
          reviewInstructions
          showReferencesToInternalDocs
          preventWidgetUsage
          allowFeedback
          generateExtendedReport
          showTimeForResponse
          showDetectedLanguage
          showRoutedModel
          isMultiLanguageEnabled
          hasMath
          hasCode
          hasComputer
          hasNER
          restrictedAccess
          restrictedAccessUsers
          splashTitle
          showSplashWhenEmpty
          llmEndpoint
          llmUrl
          llmUrlStatus
          llmUrlType
          llmBaseModel
          llmProvider
          forcedTheme
          adverserialProvider
          adverserialModel
          functionCallingProvider
          functionCallingModel
          visionProvider
          visionModel
          videoGenerationProvider
          videoGenerationModel
          showAgentName
          allowImagesUpload
          allowVideosUpload
          allowAudiosUpload
          allowDocsUpload
          allowImagesGeneration
          baseImageGenerationModel
          maxImagesGenerated
          advancedImageGeneration
          allowVideosGeneration
          allowAudiosGeneration
          voiceFileKey
          allowInternetSearch
          bannedDomains
          maxUrlsForInternetSearch
          allowDeepInternetSearch
          internetSearchModes
          internetSearchLocation
          autoVoiceMode
          keywordsWeightInRetrieval
          customCodeExecutionEnvironments
          phoneNumberAsSender
          whatsappNumberAsSender
          emailAsSender
          communicationServices
          channelCallbackDelay
          ephemeralAgent
          parentAgentID
          parentChatID
          minimumSubscriptionType
          clonedAgentID
          clonedAgentIDIcon
          hasContentCreation
          hasEntityExtraction
          department
          metadata
          allowEmailToAgent
          allowedEmails
          agentHiringTemplate
          agentDesktopVM
          agentDesktopPortRange
          agentDesktopCredentials
          agentDesktopBrowser
          allow3dModelGeneration
          agentLongTermMemory
          isLongTermMemoryEnabled
          allowExternalAPI
          forceNewThreadOnProgrammaticRequest
          dynamicModelSelectionInstructions
          contextRelevancyRatio
          reasoningBudget
          reasoningMode
          agentFnParams
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      workspaceCustomPrompts {
        items {
          id
          type
          scope
          style
          domain
          label
          promptLength
          promptPlaceholder
          interpolationString
          availableToAgents
          workspaceID
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      customQaConfig {
        roles {
          type
          label
          description
          interpolationString
          emoji
          color
          isDefault
          hasMemory
          hasTopicsContext
          allowedTopics
          defaultAnswer
          stopSequence
          enhancementPassage
          inhibitionPassage
          pertinencePassage
          goals
          qaUrl
          topK
          mode
          charting
          summarisation
          compressor
          docTopK
          maxHistory
          maxTokens
          topicEnhancer
          maxTopics
          blender
          temperature
          version
          subject
        }
      }
      aiConsumption {
        generator {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        questioner {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        translator {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        answerer {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        parser {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        tokenizer {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        embedder {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        detector {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        chatter {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        planner {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        lastUpdate
        requestsLast30Minutes
        requestsLast24Hours
      }
      disabled
      subscriptionPricingPlan {
        items {
          id
          type
          subscriptionStatus
          isPredictionOnDemandGlobal
          isTrainingOnDemandGlobal
          predictionRequestsGlobal
          batchRequestsGlobal
          trainingMinutesGlobal
          baseModelGN
          baseModelQA
          baseModelNLP
          maxUsers
          agcEnabled
          isDownloadModelEnabled
          isDownloadDataEnabled
          isAPIAccessEnabled
          isBatchJobsEnabled
          isSentimentReviewerEnabled
          isBusinessAnalystEnabled
          isContentCreatorEnabled
          isPriorityTrainingEnabled
          isPredictionGPUAccelerationEnabledGlobal
          isPredictionGPUAccelerationEnabledRC
          isPredictionGPUAccelerationEnabledNLP
          maxMrcDocs
          maxAgents
          maxSites
          maxBenchmarks
          predictionRequestsAPI
          accuracyModelEnabled
          isTrainingNLPEnabled
          isTrainingQAEnabled
          isTrainingGNEnabled
          isLongTermMemoryEnabled
          isFunctionsEnabled
          isDBFunctionsEnabled
          isHtmlFunctionsEnabled
          isSitesBindingEnabled
          isAgentsSecurityEnabled
          isWidgetChatsHistoryEnabled
          maxRequests30Minutes
          maxRequests24Hours
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      folders {
        items {
          id
          owner
          name
          description
          emoji
          status
          parent
          workspaceID
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      trainingLogs {
        items {
          id
          owner
          name
          description
          status
          trainingIterations
          lastActivation
          duration
          trainingMeta
          trainingConfig
          workspaceID
          type
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      entities {
        items {
          id
          owner
          label
          type
          description
          emoji
          parentEntity
          backgroundColor
          workspaceID
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      appLogs {
        items {
          id
          owner
          type
          filename
          event
          status
          workspaceID
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      batchJobs {
        items {
          id
          owner
          name
          description
          status
          duration
          batchMeta
          batchConfig
          batchOutput
          workspaceID
          type
          createdBy
          updatedBy
          benchmarkID
          agentID
          agentVersion
          reviewerAgentID
          reviewerAgentVersion
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      dictionaryItems {
        items {
          id
          owner
          sourceLanguage
          targetLanguage
          sourceText
          targetText
          workspaceID
          pos
          description
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      requestsLogs {
        items {
          id
          srtKey
          type
          status
          words
          tokens
          sentences
          artifactsNumber
          modelType
          outputType
          agentID
          workspaceID
          createdBy
          updatedBy
          creationTime
          isFromToothFairy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      communicationServices {
        items {
          id
          workspaceID
          name
          description
          channel
          provider
          senderid
          fromNumber
          tokenSecret
          isActive
          config
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      sites {
        items {
          id
          name
          description
          url
          workspaceID
          topics
          status
          lastValidationDate
          lastValidationRequested
          validationToken
          allowedPaths
          siteTree
          lastScraped
          skipOwnerValidation
          useProxy
          completion_percentage
          extractImages
          freeRoaming
          scrapingCycle
          imgRetrievalPrompt
          metadata
          createdBy
          updatedBy
          scapablePages
          scrapedPagesCount
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      users
      usersAccessLevel {
        items {
          id
          workspaceID
          userID
          userType
          policyID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      workspaceCreationDate
      workspaceModelReady
      enableDeleteFunctionInAgents
      enableUpdateFunctionInAgents
      enableCustomFunctionInAgents
      defaultChatAgent
      defaultBusinessAnalystAgent
      defaultContentCreatorAgent
      isSentimentReviewerEnabled
      isExtendedContentCreatorEnabled
      isExtendedBusinessAnalystReportEnabled
      customIndexedDBendpoint
      createdBy
      updatedBy
      federationMetadataUrl
      federationMetadataUrlStatus
      federationMetadataUrlType
      ssoType
      ssoDomain
      ssoProviderName
      isMultiLanguageEnabled
      customChartingConfig
      twilioConfig
      emailConfig
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onDeleteWorkspaceEvent = /* GraphQL */ `
  subscription OnDeleteWorkspaceEvent($owner: String, $id: ID) {
    onDeleteWorkspaceEvent(owner: $owner, id: $id) {
      id
      owner
      title
      visibility
      userID
      isMed
      type
      usagePlanID
      workspaceTokenID
      workspaceToken
      subscriptionType
      subscriptionId
      subscriptionStatus
      enableExperimentalFeatures
      utilityEndpoint
      utilityUrl
      utilityUrlStatus
      utilityUrlType
      utilityBaseModel
      utilityProvider
      codingEndpoint
      codingUrl
      codingUrlStatus
      codingUrlType
      codingBaseModel
      codingProvider
      generalPurposeEndpoint
      generalPurposeUrl
      generalPurposeUrlStatus
      generalPurposeUrlType
      generalPurposeBaseModel
      generalPurposeProvider
      qaEnpoint
      qaUrl
      qaUrlStatus
      qaUrlType
      qaBaseModel
      qaProvider
      cnEndpoint
      cnUrl
      cnUrlStatus
      cnUrlType
      cnBaseModel
      cnProvider
      gnEnpoint
      gnUrl
      gnUrlStatus
      gnUrlType
      gnBaseModel
      gnProvider
      nlpEnpoint
      nlpUrl
      nlpUrlStatus
      nlpUrlType
      nlpBaseModel
      nlpProvider
      embeddingEndpoint
      embeddingUrl
      embeddingUrlStatus
      embeddingUrlType
      embeddingBaseModel
      embeddingProvider
      chartingEndpoint
      chartingUrl
      chartingUrlStatus
      chartingUrlType
      chartingBaseModel
      chartingProvider
      imagingEndpoint
      imagingUrl
      imagingUrlStatus
      imagingUrlType
      imagingBaseModel
      imagingProvider
      reasoningEndpoint
      reasoningUrl
      reasoningUrlStatus
      reasoningUrlType
      reasoningBaseModel
      reasoningProvider
      billingStatus
      lastBillingDate
      lastConsumptionNotificationDate
      activeUntil
      paymentFailed
      bulkImportAllowed
      lastPaymentAttempt
      targetSubscriptionType
      lastChangeSubscriptionDate
      maxUsers
      baseModel
      domain
      trainingConfig {
        trainingIterations
        trainingIterationsNLP
        trainingIterationsRC
        trainingEpochsNLP
        trainingEpochsRC
        trainingEpochsGN
        maxStepsNLP
        patienceNLP
        learningRateNLP
        learningRateRC
        testSizeNLP
        testSizeRC
        batchSizeNLP
        batchSizeRC
        datasetTestSizeThresholdNLP
        datasetTestSizeThresholdRC
        learningRateGN
        testSizeGN
        batchSizeGN
        datasetTestSizeThresholdGN
        enableManagedSpotTraining
        maxRuntimeWaitTime
        maxRuntime
        includeReadComprehensionDataInTraining
        generateDockerImageForRCengine
        generateDockerImageForNLPengine
        generateDockerImageForGNengine
        emailsListForTrainingConfirmation
        maxQueueWaitTime
      }
      parsingConfig {
        questionsLimit
        answerAsNER
        answerByParagraph
        uniqueAnswer
        isSentenceSplitEnabled
        isImplicitSelfEnabled
        temperature
        maxTokens
        topP
        topK
        qaDocTopK
        frequencyPenalty
        presencePenalty
        qaTopP
        qaTopK
        qaMaxTokens
        qaTemperature
        qaFrequencyPenalty
        qaPresencePenalty
        qaReplyOutsidePassage
        qaAiKnowledge
        qaInhibitionPassage
        qaEnhancementPassage
        qaRole
        qaDefaultAnswer
        qaStopSequence
        stopSequence
        stopPrompt
        qaExamples {
          question
          answer
        }
        qaBlender
        agcEnabled
      }
      notificationConfig {
        emailsList
        emailOnTrainingCompleted
        emailOnBatchCompleted
        emailOnBatchFailed
        emailOnBatchStart
        emailOnTrainingFailed
        emailOnTrainingStart
        notifyAllUsersInWorkspace
        notifyOnThreasholdConsumption
        notificationThresholdConsumption
      }
      embeddingConfig {
        maxChunkWords
        maxOverlapSentences
        chunkingStrategy
        imageExtractionStrategy
        minImageWidth
        minImageHeight
        aspectRatioMin
        aspectRatioMax
      }
      customGenerationConfig {
        styles
        domains
        scopes
        prompts {
          type
          label
          promptLength
          promptPlaceholder
          interpolationString
        }
        hasTopicsContext
        topics
        docTopK
        topK
        blender
        mode
        aiKnowledge
        compressor
      }
      customImageRecognitionModel
      customVectorDB
      workspaceAgents {
        items {
          id
          type
          label
          description
          interpolationString
          emoji
          color
          darkColor
          icon
          largeLogo
          icoUrl
          logoBackground
          darkLogoBackground
          messageOnLaunch
          messagesOnLaunch
          rotateMessagesOnLaunch
          rotateMessagesOnLaunchInterval
          placeholderMessageOnLoading
          customGreetingInstructions
          customConclusionInstructions
          customChartingInstructions
          customSummarisationInstructions
          customImagesInstructions
          customToolingInstructions
          placeholderInputMessage
          openByDefault
          disclaimer
          showDocumentsReferences
          isDefault
          hasMemory
          hasImages
          promptTopKeywords
          keyWordsForKnowledgeBase
          hasTopicsContext
          hasFunctions
          advancedLanguageDetection
          allowedTopics
          staticDocs
          defaultAnswer
          noKnowledgeDefaultAnswer
          quickQuestions
          recencyImportance
          maxRecencyIncrease
          recencyTopKIncreaseFactor
          stopSequence
          enhancementPassage
          inhibitionPassage
          pertinencePassage
          goals
          qaUrl
          topK
          mode
          showCodeInExecution
          hideReasoning
          charting
          summarisation
          compressor
          docTopK
          minRetrievalScore
          timeSignificance
          hasModeration
          customModerations
          moderationMessage
          languageDetectionConfidence
          maxHistory
          maxTokens
          topicEnhancer
          maxTopics
          blender
          temperature
          version
          subject
          workspaceID
          createdBy
          updatedBy
          agentFunctions
          isGlobal
          promptBuffering
          functionContext
          plainTextOutput
          chainOfThoughts
          treeOfThoughts
          extendedOutput
          agentType
          agentsPool
          mcps
          maxPlanningSteps
          virtualDesktopInstructions
          planningInstructions
          plannerExecutionAttempts
          plannerRequiresApprovalForPlanExecution
          plannerEmailOnApprovalRequest
          plannerEmailOnFailedPlan
          plannerEmailOnCompletedPlan
          plannerAutoAgentSpawn
          plannerRetainsSpawnedAgents
          plannerPromptsAgentsProgrammatically
          plannerDeepThinking
          allowReplanning
          plannerProceedsWhenImprovementsRequired
          plannerApproverEmails
          reviewInstructions
          showReferencesToInternalDocs
          preventWidgetUsage
          allowFeedback
          generateExtendedReport
          showTimeForResponse
          showDetectedLanguage
          showRoutedModel
          isMultiLanguageEnabled
          hasMath
          hasCode
          hasComputer
          hasNER
          restrictedAccess
          restrictedAccessUsers
          splashTitle
          showSplashWhenEmpty
          llmEndpoint
          llmUrl
          llmUrlStatus
          llmUrlType
          llmBaseModel
          llmProvider
          forcedTheme
          adverserialProvider
          adverserialModel
          functionCallingProvider
          functionCallingModel
          visionProvider
          visionModel
          videoGenerationProvider
          videoGenerationModel
          showAgentName
          allowImagesUpload
          allowVideosUpload
          allowAudiosUpload
          allowDocsUpload
          allowImagesGeneration
          baseImageGenerationModel
          maxImagesGenerated
          advancedImageGeneration
          allowVideosGeneration
          allowAudiosGeneration
          voiceFileKey
          allowInternetSearch
          bannedDomains
          maxUrlsForInternetSearch
          allowDeepInternetSearch
          internetSearchModes
          internetSearchLocation
          autoVoiceMode
          keywordsWeightInRetrieval
          customCodeExecutionEnvironments
          phoneNumberAsSender
          whatsappNumberAsSender
          emailAsSender
          communicationServices
          channelCallbackDelay
          ephemeralAgent
          parentAgentID
          parentChatID
          minimumSubscriptionType
          clonedAgentID
          clonedAgentIDIcon
          hasContentCreation
          hasEntityExtraction
          department
          metadata
          allowEmailToAgent
          allowedEmails
          agentHiringTemplate
          agentDesktopVM
          agentDesktopPortRange
          agentDesktopCredentials
          agentDesktopBrowser
          allow3dModelGeneration
          agentLongTermMemory
          isLongTermMemoryEnabled
          allowExternalAPI
          forceNewThreadOnProgrammaticRequest
          dynamicModelSelectionInstructions
          contextRelevancyRatio
          reasoningBudget
          reasoningMode
          agentFnParams
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      workspaceCustomPrompts {
        items {
          id
          type
          scope
          style
          domain
          label
          promptLength
          promptPlaceholder
          interpolationString
          availableToAgents
          workspaceID
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      customQaConfig {
        roles {
          type
          label
          description
          interpolationString
          emoji
          color
          isDefault
          hasMemory
          hasTopicsContext
          allowedTopics
          defaultAnswer
          stopSequence
          enhancementPassage
          inhibitionPassage
          pertinencePassage
          goals
          qaUrl
          topK
          mode
          charting
          summarisation
          compressor
          docTopK
          maxHistory
          maxTokens
          topicEnhancer
          maxTopics
          blender
          temperature
          version
          subject
        }
      }
      aiConsumption {
        generator {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        questioner {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        translator {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        answerer {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        parser {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        tokenizer {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        embedder {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        detector {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        chatter {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        planner {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        lastUpdate
        requestsLast30Minutes
        requestsLast24Hours
      }
      disabled
      subscriptionPricingPlan {
        items {
          id
          type
          subscriptionStatus
          isPredictionOnDemandGlobal
          isTrainingOnDemandGlobal
          predictionRequestsGlobal
          batchRequestsGlobal
          trainingMinutesGlobal
          baseModelGN
          baseModelQA
          baseModelNLP
          maxUsers
          agcEnabled
          isDownloadModelEnabled
          isDownloadDataEnabled
          isAPIAccessEnabled
          isBatchJobsEnabled
          isSentimentReviewerEnabled
          isBusinessAnalystEnabled
          isContentCreatorEnabled
          isPriorityTrainingEnabled
          isPredictionGPUAccelerationEnabledGlobal
          isPredictionGPUAccelerationEnabledRC
          isPredictionGPUAccelerationEnabledNLP
          maxMrcDocs
          maxAgents
          maxSites
          maxBenchmarks
          predictionRequestsAPI
          accuracyModelEnabled
          isTrainingNLPEnabled
          isTrainingQAEnabled
          isTrainingGNEnabled
          isLongTermMemoryEnabled
          isFunctionsEnabled
          isDBFunctionsEnabled
          isHtmlFunctionsEnabled
          isSitesBindingEnabled
          isAgentsSecurityEnabled
          isWidgetChatsHistoryEnabled
          maxRequests30Minutes
          maxRequests24Hours
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      folders {
        items {
          id
          owner
          name
          description
          emoji
          status
          parent
          workspaceID
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      trainingLogs {
        items {
          id
          owner
          name
          description
          status
          trainingIterations
          lastActivation
          duration
          trainingMeta
          trainingConfig
          workspaceID
          type
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      entities {
        items {
          id
          owner
          label
          type
          description
          emoji
          parentEntity
          backgroundColor
          workspaceID
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      appLogs {
        items {
          id
          owner
          type
          filename
          event
          status
          workspaceID
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      batchJobs {
        items {
          id
          owner
          name
          description
          status
          duration
          batchMeta
          batchConfig
          batchOutput
          workspaceID
          type
          createdBy
          updatedBy
          benchmarkID
          agentID
          agentVersion
          reviewerAgentID
          reviewerAgentVersion
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      dictionaryItems {
        items {
          id
          owner
          sourceLanguage
          targetLanguage
          sourceText
          targetText
          workspaceID
          pos
          description
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      requestsLogs {
        items {
          id
          srtKey
          type
          status
          words
          tokens
          sentences
          artifactsNumber
          modelType
          outputType
          agentID
          workspaceID
          createdBy
          updatedBy
          creationTime
          isFromToothFairy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      communicationServices {
        items {
          id
          workspaceID
          name
          description
          channel
          provider
          senderid
          fromNumber
          tokenSecret
          isActive
          config
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      sites {
        items {
          id
          name
          description
          url
          workspaceID
          topics
          status
          lastValidationDate
          lastValidationRequested
          validationToken
          allowedPaths
          siteTree
          lastScraped
          skipOwnerValidation
          useProxy
          completion_percentage
          extractImages
          freeRoaming
          scrapingCycle
          imgRetrievalPrompt
          metadata
          createdBy
          updatedBy
          scapablePages
          scrapedPagesCount
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      users
      usersAccessLevel {
        items {
          id
          workspaceID
          userID
          userType
          policyID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      workspaceCreationDate
      workspaceModelReady
      enableDeleteFunctionInAgents
      enableUpdateFunctionInAgents
      enableCustomFunctionInAgents
      defaultChatAgent
      defaultBusinessAnalystAgent
      defaultContentCreatorAgent
      isSentimentReviewerEnabled
      isExtendedContentCreatorEnabled
      isExtendedBusinessAnalystReportEnabled
      customIndexedDBendpoint
      createdBy
      updatedBy
      federationMetadataUrl
      federationMetadataUrlStatus
      federationMetadataUrlType
      ssoType
      ssoDomain
      ssoProviderName
      isMultiLanguageEnabled
      customChartingConfig
      twilioConfig
      emailConfig
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onCreateEntityAIEvent = /* GraphQL */ `
  subscription OnCreateEntityAIEvent($owner: String, $workspaceID: ID) {
    onCreateEntityAIEvent(owner: $owner, workspaceID: $workspaceID) {
      id
      owner
      label
      type
      description
      emoji
      parentEntity
      backgroundColor
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onUpdateEntityAIEvent = /* GraphQL */ `
  subscription OnUpdateEntityAIEvent(
    $owner: String
    $workspaceID: ID
    $id: ID
  ) {
    onUpdateEntityAIEvent(owner: $owner, workspaceID: $workspaceID, id: $id) {
      id
      owner
      label
      type
      description
      emoji
      parentEntity
      backgroundColor
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onDeleteEntityAIEvent = /* GraphQL */ `
  subscription OnDeleteEntityAIEvent(
    $owner: String
    $workspaceID: ID
    $id: ID
  ) {
    onDeleteEntityAIEvent(owner: $owner, workspaceID: $workspaceID, id: $id) {
      id
      owner
      label
      type
      description
      emoji
      parentEntity
      backgroundColor
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onCreateTrainingLogEvent = /* GraphQL */ `
  subscription OnCreateTrainingLogEvent($owner: String, $workspaceID: ID) {
    onCreateTrainingLogEvent(owner: $owner, workspaceID: $workspaceID) {
      id
      owner
      name
      description
      status
      trainingIterations
      lastActivation
      duration
      trainingMeta
      trainingConfig
      workspaceID
      type
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onUpdateTrainingLogEvent = /* GraphQL */ `
  subscription OnUpdateTrainingLogEvent(
    $owner: String
    $workspaceID: ID
    $id: ID
  ) {
    onUpdateTrainingLogEvent(
      owner: $owner
      workspaceID: $workspaceID
      id: $id
    ) {
      id
      owner
      name
      description
      status
      trainingIterations
      lastActivation
      duration
      trainingMeta
      trainingConfig
      workspaceID
      type
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onDeleteTrainingLogEvent = /* GraphQL */ `
  subscription OnDeleteTrainingLogEvent(
    $owner: String
    $workspaceID: ID
    $id: ID
  ) {
    onDeleteTrainingLogEvent(
      owner: $owner
      workspaceID: $workspaceID
      id: $id
    ) {
      id
      owner
      name
      description
      status
      trainingIterations
      lastActivation
      duration
      trainingMeta
      trainingConfig
      workspaceID
      type
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onCreateAppConfig = /* GraphQL */ `
  subscription OnCreateAppConfig(
    $filter: ModelSubscriptionAppConfigFilterInput
  ) {
    onCreateAppConfig(filter: $filter) {
      id
      saveTimer
      screenResponsiveWidth
      mobileResponsiveWidth
      veryLargeScreenResponsiveWidth
      chartMaxHeight
      inactiveTimeout
      sideMenuWidth
      availableLanguages
      baseIntents
      baseEntities
      baseTopics
      supportDomain
      metadata
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onUpdateAppConfig = /* GraphQL */ `
  subscription OnUpdateAppConfig(
    $filter: ModelSubscriptionAppConfigFilterInput
  ) {
    onUpdateAppConfig(filter: $filter) {
      id
      saveTimer
      screenResponsiveWidth
      mobileResponsiveWidth
      veryLargeScreenResponsiveWidth
      chartMaxHeight
      inactiveTimeout
      sideMenuWidth
      availableLanguages
      baseIntents
      baseEntities
      baseTopics
      supportDomain
      metadata
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onDeleteAppConfig = /* GraphQL */ `
  subscription OnDeleteAppConfig(
    $filter: ModelSubscriptionAppConfigFilterInput
  ) {
    onDeleteAppConfig(filter: $filter) {
      id
      saveTimer
      screenResponsiveWidth
      mobileResponsiveWidth
      veryLargeScreenResponsiveWidth
      chartMaxHeight
      inactiveTimeout
      sideMenuWidth
      availableLanguages
      baseIntents
      baseEntities
      baseTopics
      supportDomain
      metadata
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onCreateUser = /* GraphQL */ `
  subscription OnCreateUser(
    $filter: ModelSubscriptionUserFilterInput
    $owner: String
  ) {
    onCreateUser(filter: $filter, owner: $owner) {
      id
      owner
      username
      user_email
      user_email_verified
      user_phone_number
      timezone
      language
      isSentenceSplitEnabled
      isImplicitSelfEnabled
      replyLanguage
      theme
      user_phone_number_verified
      userInstructions
      userMemories
      isOnboarded
      userHelperPreferences
      type
      workspaces {
        items {
          id
          owner
          title
          visibility
          userID
          isMed
          type
          usagePlanID
          workspaceTokenID
          workspaceToken
          subscriptionType
          subscriptionId
          subscriptionStatus
          enableExperimentalFeatures
          utilityEndpoint
          utilityUrl
          utilityUrlStatus
          utilityUrlType
          utilityBaseModel
          utilityProvider
          codingEndpoint
          codingUrl
          codingUrlStatus
          codingUrlType
          codingBaseModel
          codingProvider
          generalPurposeEndpoint
          generalPurposeUrl
          generalPurposeUrlStatus
          generalPurposeUrlType
          generalPurposeBaseModel
          generalPurposeProvider
          qaEnpoint
          qaUrl
          qaUrlStatus
          qaUrlType
          qaBaseModel
          qaProvider
          cnEndpoint
          cnUrl
          cnUrlStatus
          cnUrlType
          cnBaseModel
          cnProvider
          gnEnpoint
          gnUrl
          gnUrlStatus
          gnUrlType
          gnBaseModel
          gnProvider
          nlpEnpoint
          nlpUrl
          nlpUrlStatus
          nlpUrlType
          nlpBaseModel
          nlpProvider
          embeddingEndpoint
          embeddingUrl
          embeddingUrlStatus
          embeddingUrlType
          embeddingBaseModel
          embeddingProvider
          chartingEndpoint
          chartingUrl
          chartingUrlStatus
          chartingUrlType
          chartingBaseModel
          chartingProvider
          imagingEndpoint
          imagingUrl
          imagingUrlStatus
          imagingUrlType
          imagingBaseModel
          imagingProvider
          reasoningEndpoint
          reasoningUrl
          reasoningUrlStatus
          reasoningUrlType
          reasoningBaseModel
          reasoningProvider
          billingStatus
          lastBillingDate
          lastConsumptionNotificationDate
          activeUntil
          paymentFailed
          bulkImportAllowed
          lastPaymentAttempt
          targetSubscriptionType
          lastChangeSubscriptionDate
          maxUsers
          baseModel
          domain
          customImageRecognitionModel
          customVectorDB
          disabled
          users
          workspaceCreationDate
          workspaceModelReady
          enableDeleteFunctionInAgents
          enableUpdateFunctionInAgents
          enableCustomFunctionInAgents
          defaultChatAgent
          defaultBusinessAnalystAgent
          defaultContentCreatorAgent
          isSentimentReviewerEnabled
          isExtendedContentCreatorEnabled
          isExtendedBusinessAnalystReportEnabled
          customIndexedDBendpoint
          createdBy
          updatedBy
          federationMetadataUrl
          federationMetadataUrlStatus
          federationMetadataUrlType
          ssoType
          ssoDomain
          ssoProviderName
          isMultiLanguageEnabled
          customChartingConfig
          twilioConfig
          emailConfig
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      cognitoUsername
      stripeCustomerId
      subscribedToNewsletter
      isLead
      stripePaymentIntentId
      maximumNumberOfWorkspaces
      workspacesAccessLevel {
        items {
          id
          workspaceID
          userID
          userType
          policyID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onUpdateUser = /* GraphQL */ `
  subscription OnUpdateUser(
    $filter: ModelSubscriptionUserFilterInput
    $owner: String
  ) {
    onUpdateUser(filter: $filter, owner: $owner) {
      id
      owner
      username
      user_email
      user_email_verified
      user_phone_number
      timezone
      language
      isSentenceSplitEnabled
      isImplicitSelfEnabled
      replyLanguage
      theme
      user_phone_number_verified
      userInstructions
      userMemories
      isOnboarded
      userHelperPreferences
      type
      workspaces {
        items {
          id
          owner
          title
          visibility
          userID
          isMed
          type
          usagePlanID
          workspaceTokenID
          workspaceToken
          subscriptionType
          subscriptionId
          subscriptionStatus
          enableExperimentalFeatures
          utilityEndpoint
          utilityUrl
          utilityUrlStatus
          utilityUrlType
          utilityBaseModel
          utilityProvider
          codingEndpoint
          codingUrl
          codingUrlStatus
          codingUrlType
          codingBaseModel
          codingProvider
          generalPurposeEndpoint
          generalPurposeUrl
          generalPurposeUrlStatus
          generalPurposeUrlType
          generalPurposeBaseModel
          generalPurposeProvider
          qaEnpoint
          qaUrl
          qaUrlStatus
          qaUrlType
          qaBaseModel
          qaProvider
          cnEndpoint
          cnUrl
          cnUrlStatus
          cnUrlType
          cnBaseModel
          cnProvider
          gnEnpoint
          gnUrl
          gnUrlStatus
          gnUrlType
          gnBaseModel
          gnProvider
          nlpEnpoint
          nlpUrl
          nlpUrlStatus
          nlpUrlType
          nlpBaseModel
          nlpProvider
          embeddingEndpoint
          embeddingUrl
          embeddingUrlStatus
          embeddingUrlType
          embeddingBaseModel
          embeddingProvider
          chartingEndpoint
          chartingUrl
          chartingUrlStatus
          chartingUrlType
          chartingBaseModel
          chartingProvider
          imagingEndpoint
          imagingUrl
          imagingUrlStatus
          imagingUrlType
          imagingBaseModel
          imagingProvider
          reasoningEndpoint
          reasoningUrl
          reasoningUrlStatus
          reasoningUrlType
          reasoningBaseModel
          reasoningProvider
          billingStatus
          lastBillingDate
          lastConsumptionNotificationDate
          activeUntil
          paymentFailed
          bulkImportAllowed
          lastPaymentAttempt
          targetSubscriptionType
          lastChangeSubscriptionDate
          maxUsers
          baseModel
          domain
          customImageRecognitionModel
          customVectorDB
          disabled
          users
          workspaceCreationDate
          workspaceModelReady
          enableDeleteFunctionInAgents
          enableUpdateFunctionInAgents
          enableCustomFunctionInAgents
          defaultChatAgent
          defaultBusinessAnalystAgent
          defaultContentCreatorAgent
          isSentimentReviewerEnabled
          isExtendedContentCreatorEnabled
          isExtendedBusinessAnalystReportEnabled
          customIndexedDBendpoint
          createdBy
          updatedBy
          federationMetadataUrl
          federationMetadataUrlStatus
          federationMetadataUrlType
          ssoType
          ssoDomain
          ssoProviderName
          isMultiLanguageEnabled
          customChartingConfig
          twilioConfig
          emailConfig
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      cognitoUsername
      stripeCustomerId
      subscribedToNewsletter
      isLead
      stripePaymentIntentId
      maximumNumberOfWorkspaces
      workspacesAccessLevel {
        items {
          id
          workspaceID
          userID
          userType
          policyID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onDeleteUser = /* GraphQL */ `
  subscription OnDeleteUser(
    $filter: ModelSubscriptionUserFilterInput
    $owner: String
  ) {
    onDeleteUser(filter: $filter, owner: $owner) {
      id
      owner
      username
      user_email
      user_email_verified
      user_phone_number
      timezone
      language
      isSentenceSplitEnabled
      isImplicitSelfEnabled
      replyLanguage
      theme
      user_phone_number_verified
      userInstructions
      userMemories
      isOnboarded
      userHelperPreferences
      type
      workspaces {
        items {
          id
          owner
          title
          visibility
          userID
          isMed
          type
          usagePlanID
          workspaceTokenID
          workspaceToken
          subscriptionType
          subscriptionId
          subscriptionStatus
          enableExperimentalFeatures
          utilityEndpoint
          utilityUrl
          utilityUrlStatus
          utilityUrlType
          utilityBaseModel
          utilityProvider
          codingEndpoint
          codingUrl
          codingUrlStatus
          codingUrlType
          codingBaseModel
          codingProvider
          generalPurposeEndpoint
          generalPurposeUrl
          generalPurposeUrlStatus
          generalPurposeUrlType
          generalPurposeBaseModel
          generalPurposeProvider
          qaEnpoint
          qaUrl
          qaUrlStatus
          qaUrlType
          qaBaseModel
          qaProvider
          cnEndpoint
          cnUrl
          cnUrlStatus
          cnUrlType
          cnBaseModel
          cnProvider
          gnEnpoint
          gnUrl
          gnUrlStatus
          gnUrlType
          gnBaseModel
          gnProvider
          nlpEnpoint
          nlpUrl
          nlpUrlStatus
          nlpUrlType
          nlpBaseModel
          nlpProvider
          embeddingEndpoint
          embeddingUrl
          embeddingUrlStatus
          embeddingUrlType
          embeddingBaseModel
          embeddingProvider
          chartingEndpoint
          chartingUrl
          chartingUrlStatus
          chartingUrlType
          chartingBaseModel
          chartingProvider
          imagingEndpoint
          imagingUrl
          imagingUrlStatus
          imagingUrlType
          imagingBaseModel
          imagingProvider
          reasoningEndpoint
          reasoningUrl
          reasoningUrlStatus
          reasoningUrlType
          reasoningBaseModel
          reasoningProvider
          billingStatus
          lastBillingDate
          lastConsumptionNotificationDate
          activeUntil
          paymentFailed
          bulkImportAllowed
          lastPaymentAttempt
          targetSubscriptionType
          lastChangeSubscriptionDate
          maxUsers
          baseModel
          domain
          customImageRecognitionModel
          customVectorDB
          disabled
          users
          workspaceCreationDate
          workspaceModelReady
          enableDeleteFunctionInAgents
          enableUpdateFunctionInAgents
          enableCustomFunctionInAgents
          defaultChatAgent
          defaultBusinessAnalystAgent
          defaultContentCreatorAgent
          isSentimentReviewerEnabled
          isExtendedContentCreatorEnabled
          isExtendedBusinessAnalystReportEnabled
          customIndexedDBendpoint
          createdBy
          updatedBy
          federationMetadataUrl
          federationMetadataUrlStatus
          federationMetadataUrlType
          ssoType
          ssoDomain
          ssoProviderName
          isMultiLanguageEnabled
          customChartingConfig
          twilioConfig
          emailConfig
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      cognitoUsername
      stripeCustomerId
      subscribedToNewsletter
      isLead
      stripePaymentIntentId
      maximumNumberOfWorkspaces
      workspacesAccessLevel {
        items {
          id
          workspaceID
          userID
          userType
          policyID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onCreateWorkspace = /* GraphQL */ `
  subscription OnCreateWorkspace(
    $filter: ModelSubscriptionWorkspaceFilterInput
  ) {
    onCreateWorkspace(filter: $filter) {
      id
      owner
      title
      visibility
      userID
      isMed
      type
      usagePlanID
      workspaceTokenID
      workspaceToken
      subscriptionType
      subscriptionId
      subscriptionStatus
      enableExperimentalFeatures
      utilityEndpoint
      utilityUrl
      utilityUrlStatus
      utilityUrlType
      utilityBaseModel
      utilityProvider
      codingEndpoint
      codingUrl
      codingUrlStatus
      codingUrlType
      codingBaseModel
      codingProvider
      generalPurposeEndpoint
      generalPurposeUrl
      generalPurposeUrlStatus
      generalPurposeUrlType
      generalPurposeBaseModel
      generalPurposeProvider
      qaEnpoint
      qaUrl
      qaUrlStatus
      qaUrlType
      qaBaseModel
      qaProvider
      cnEndpoint
      cnUrl
      cnUrlStatus
      cnUrlType
      cnBaseModel
      cnProvider
      gnEnpoint
      gnUrl
      gnUrlStatus
      gnUrlType
      gnBaseModel
      gnProvider
      nlpEnpoint
      nlpUrl
      nlpUrlStatus
      nlpUrlType
      nlpBaseModel
      nlpProvider
      embeddingEndpoint
      embeddingUrl
      embeddingUrlStatus
      embeddingUrlType
      embeddingBaseModel
      embeddingProvider
      chartingEndpoint
      chartingUrl
      chartingUrlStatus
      chartingUrlType
      chartingBaseModel
      chartingProvider
      imagingEndpoint
      imagingUrl
      imagingUrlStatus
      imagingUrlType
      imagingBaseModel
      imagingProvider
      reasoningEndpoint
      reasoningUrl
      reasoningUrlStatus
      reasoningUrlType
      reasoningBaseModel
      reasoningProvider
      billingStatus
      lastBillingDate
      lastConsumptionNotificationDate
      activeUntil
      paymentFailed
      bulkImportAllowed
      lastPaymentAttempt
      targetSubscriptionType
      lastChangeSubscriptionDate
      maxUsers
      baseModel
      domain
      trainingConfig {
        trainingIterations
        trainingIterationsNLP
        trainingIterationsRC
        trainingEpochsNLP
        trainingEpochsRC
        trainingEpochsGN
        maxStepsNLP
        patienceNLP
        learningRateNLP
        learningRateRC
        testSizeNLP
        testSizeRC
        batchSizeNLP
        batchSizeRC
        datasetTestSizeThresholdNLP
        datasetTestSizeThresholdRC
        learningRateGN
        testSizeGN
        batchSizeGN
        datasetTestSizeThresholdGN
        enableManagedSpotTraining
        maxRuntimeWaitTime
        maxRuntime
        includeReadComprehensionDataInTraining
        generateDockerImageForRCengine
        generateDockerImageForNLPengine
        generateDockerImageForGNengine
        emailsListForTrainingConfirmation
        maxQueueWaitTime
      }
      parsingConfig {
        questionsLimit
        answerAsNER
        answerByParagraph
        uniqueAnswer
        isSentenceSplitEnabled
        isImplicitSelfEnabled
        temperature
        maxTokens
        topP
        topK
        qaDocTopK
        frequencyPenalty
        presencePenalty
        qaTopP
        qaTopK
        qaMaxTokens
        qaTemperature
        qaFrequencyPenalty
        qaPresencePenalty
        qaReplyOutsidePassage
        qaAiKnowledge
        qaInhibitionPassage
        qaEnhancementPassage
        qaRole
        qaDefaultAnswer
        qaStopSequence
        stopSequence
        stopPrompt
        qaExamples {
          question
          answer
        }
        qaBlender
        agcEnabled
      }
      notificationConfig {
        emailsList
        emailOnTrainingCompleted
        emailOnBatchCompleted
        emailOnBatchFailed
        emailOnBatchStart
        emailOnTrainingFailed
        emailOnTrainingStart
        notifyAllUsersInWorkspace
        notifyOnThreasholdConsumption
        notificationThresholdConsumption
      }
      embeddingConfig {
        maxChunkWords
        maxOverlapSentences
        chunkingStrategy
        imageExtractionStrategy
        minImageWidth
        minImageHeight
        aspectRatioMin
        aspectRatioMax
      }
      customGenerationConfig {
        styles
        domains
        scopes
        prompts {
          type
          label
          promptLength
          promptPlaceholder
          interpolationString
        }
        hasTopicsContext
        topics
        docTopK
        topK
        blender
        mode
        aiKnowledge
        compressor
      }
      customImageRecognitionModel
      customVectorDB
      workspaceAgents {
        items {
          id
          type
          label
          description
          interpolationString
          emoji
          color
          darkColor
          icon
          largeLogo
          icoUrl
          logoBackground
          darkLogoBackground
          messageOnLaunch
          messagesOnLaunch
          rotateMessagesOnLaunch
          rotateMessagesOnLaunchInterval
          placeholderMessageOnLoading
          customGreetingInstructions
          customConclusionInstructions
          customChartingInstructions
          customSummarisationInstructions
          customImagesInstructions
          customToolingInstructions
          placeholderInputMessage
          openByDefault
          disclaimer
          showDocumentsReferences
          isDefault
          hasMemory
          hasImages
          promptTopKeywords
          keyWordsForKnowledgeBase
          hasTopicsContext
          hasFunctions
          advancedLanguageDetection
          allowedTopics
          staticDocs
          defaultAnswer
          noKnowledgeDefaultAnswer
          quickQuestions
          recencyImportance
          maxRecencyIncrease
          recencyTopKIncreaseFactor
          stopSequence
          enhancementPassage
          inhibitionPassage
          pertinencePassage
          goals
          qaUrl
          topK
          mode
          showCodeInExecution
          hideReasoning
          charting
          summarisation
          compressor
          docTopK
          minRetrievalScore
          timeSignificance
          hasModeration
          customModerations
          moderationMessage
          languageDetectionConfidence
          maxHistory
          maxTokens
          topicEnhancer
          maxTopics
          blender
          temperature
          version
          subject
          workspaceID
          createdBy
          updatedBy
          agentFunctions
          isGlobal
          promptBuffering
          functionContext
          plainTextOutput
          chainOfThoughts
          treeOfThoughts
          extendedOutput
          agentType
          agentsPool
          mcps
          maxPlanningSteps
          virtualDesktopInstructions
          planningInstructions
          plannerExecutionAttempts
          plannerRequiresApprovalForPlanExecution
          plannerEmailOnApprovalRequest
          plannerEmailOnFailedPlan
          plannerEmailOnCompletedPlan
          plannerAutoAgentSpawn
          plannerRetainsSpawnedAgents
          plannerPromptsAgentsProgrammatically
          plannerDeepThinking
          allowReplanning
          plannerProceedsWhenImprovementsRequired
          plannerApproverEmails
          reviewInstructions
          showReferencesToInternalDocs
          preventWidgetUsage
          allowFeedback
          generateExtendedReport
          showTimeForResponse
          showDetectedLanguage
          showRoutedModel
          isMultiLanguageEnabled
          hasMath
          hasCode
          hasComputer
          hasNER
          restrictedAccess
          restrictedAccessUsers
          splashTitle
          showSplashWhenEmpty
          llmEndpoint
          llmUrl
          llmUrlStatus
          llmUrlType
          llmBaseModel
          llmProvider
          forcedTheme
          adverserialProvider
          adverserialModel
          functionCallingProvider
          functionCallingModel
          visionProvider
          visionModel
          videoGenerationProvider
          videoGenerationModel
          showAgentName
          allowImagesUpload
          allowVideosUpload
          allowAudiosUpload
          allowDocsUpload
          allowImagesGeneration
          baseImageGenerationModel
          maxImagesGenerated
          advancedImageGeneration
          allowVideosGeneration
          allowAudiosGeneration
          voiceFileKey
          allowInternetSearch
          bannedDomains
          maxUrlsForInternetSearch
          allowDeepInternetSearch
          internetSearchModes
          internetSearchLocation
          autoVoiceMode
          keywordsWeightInRetrieval
          customCodeExecutionEnvironments
          phoneNumberAsSender
          whatsappNumberAsSender
          emailAsSender
          communicationServices
          channelCallbackDelay
          ephemeralAgent
          parentAgentID
          parentChatID
          minimumSubscriptionType
          clonedAgentID
          clonedAgentIDIcon
          hasContentCreation
          hasEntityExtraction
          department
          metadata
          allowEmailToAgent
          allowedEmails
          agentHiringTemplate
          agentDesktopVM
          agentDesktopPortRange
          agentDesktopCredentials
          agentDesktopBrowser
          allow3dModelGeneration
          agentLongTermMemory
          isLongTermMemoryEnabled
          allowExternalAPI
          forceNewThreadOnProgrammaticRequest
          dynamicModelSelectionInstructions
          contextRelevancyRatio
          reasoningBudget
          reasoningMode
          agentFnParams
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      workspaceCustomPrompts {
        items {
          id
          type
          scope
          style
          domain
          label
          promptLength
          promptPlaceholder
          interpolationString
          availableToAgents
          workspaceID
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      customQaConfig {
        roles {
          type
          label
          description
          interpolationString
          emoji
          color
          isDefault
          hasMemory
          hasTopicsContext
          allowedTopics
          defaultAnswer
          stopSequence
          enhancementPassage
          inhibitionPassage
          pertinencePassage
          goals
          qaUrl
          topK
          mode
          charting
          summarisation
          compressor
          docTopK
          maxHistory
          maxTokens
          topicEnhancer
          maxTopics
          blender
          temperature
          version
          subject
        }
      }
      aiConsumption {
        generator {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        questioner {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        translator {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        answerer {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        parser {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        tokenizer {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        embedder {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        detector {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        chatter {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        planner {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        lastUpdate
        requestsLast30Minutes
        requestsLast24Hours
      }
      disabled
      subscriptionPricingPlan {
        items {
          id
          type
          subscriptionStatus
          isPredictionOnDemandGlobal
          isTrainingOnDemandGlobal
          predictionRequestsGlobal
          batchRequestsGlobal
          trainingMinutesGlobal
          baseModelGN
          baseModelQA
          baseModelNLP
          maxUsers
          agcEnabled
          isDownloadModelEnabled
          isDownloadDataEnabled
          isAPIAccessEnabled
          isBatchJobsEnabled
          isSentimentReviewerEnabled
          isBusinessAnalystEnabled
          isContentCreatorEnabled
          isPriorityTrainingEnabled
          isPredictionGPUAccelerationEnabledGlobal
          isPredictionGPUAccelerationEnabledRC
          isPredictionGPUAccelerationEnabledNLP
          maxMrcDocs
          maxAgents
          maxSites
          maxBenchmarks
          predictionRequestsAPI
          accuracyModelEnabled
          isTrainingNLPEnabled
          isTrainingQAEnabled
          isTrainingGNEnabled
          isLongTermMemoryEnabled
          isFunctionsEnabled
          isDBFunctionsEnabled
          isHtmlFunctionsEnabled
          isSitesBindingEnabled
          isAgentsSecurityEnabled
          isWidgetChatsHistoryEnabled
          maxRequests30Minutes
          maxRequests24Hours
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      folders {
        items {
          id
          owner
          name
          description
          emoji
          status
          parent
          workspaceID
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      trainingLogs {
        items {
          id
          owner
          name
          description
          status
          trainingIterations
          lastActivation
          duration
          trainingMeta
          trainingConfig
          workspaceID
          type
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      entities {
        items {
          id
          owner
          label
          type
          description
          emoji
          parentEntity
          backgroundColor
          workspaceID
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      appLogs {
        items {
          id
          owner
          type
          filename
          event
          status
          workspaceID
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      batchJobs {
        items {
          id
          owner
          name
          description
          status
          duration
          batchMeta
          batchConfig
          batchOutput
          workspaceID
          type
          createdBy
          updatedBy
          benchmarkID
          agentID
          agentVersion
          reviewerAgentID
          reviewerAgentVersion
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      dictionaryItems {
        items {
          id
          owner
          sourceLanguage
          targetLanguage
          sourceText
          targetText
          workspaceID
          pos
          description
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      requestsLogs {
        items {
          id
          srtKey
          type
          status
          words
          tokens
          sentences
          artifactsNumber
          modelType
          outputType
          agentID
          workspaceID
          createdBy
          updatedBy
          creationTime
          isFromToothFairy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      communicationServices {
        items {
          id
          workspaceID
          name
          description
          channel
          provider
          senderid
          fromNumber
          tokenSecret
          isActive
          config
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      sites {
        items {
          id
          name
          description
          url
          workspaceID
          topics
          status
          lastValidationDate
          lastValidationRequested
          validationToken
          allowedPaths
          siteTree
          lastScraped
          skipOwnerValidation
          useProxy
          completion_percentage
          extractImages
          freeRoaming
          scrapingCycle
          imgRetrievalPrompt
          metadata
          createdBy
          updatedBy
          scapablePages
          scrapedPagesCount
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      users
      usersAccessLevel {
        items {
          id
          workspaceID
          userID
          userType
          policyID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      workspaceCreationDate
      workspaceModelReady
      enableDeleteFunctionInAgents
      enableUpdateFunctionInAgents
      enableCustomFunctionInAgents
      defaultChatAgent
      defaultBusinessAnalystAgent
      defaultContentCreatorAgent
      isSentimentReviewerEnabled
      isExtendedContentCreatorEnabled
      isExtendedBusinessAnalystReportEnabled
      customIndexedDBendpoint
      createdBy
      updatedBy
      federationMetadataUrl
      federationMetadataUrlStatus
      federationMetadataUrlType
      ssoType
      ssoDomain
      ssoProviderName
      isMultiLanguageEnabled
      customChartingConfig
      twilioConfig
      emailConfig
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onUpdateWorkspace = /* GraphQL */ `
  subscription OnUpdateWorkspace(
    $filter: ModelSubscriptionWorkspaceFilterInput
  ) {
    onUpdateWorkspace(filter: $filter) {
      id
      owner
      title
      visibility
      userID
      isMed
      type
      usagePlanID
      workspaceTokenID
      workspaceToken
      subscriptionType
      subscriptionId
      subscriptionStatus
      enableExperimentalFeatures
      utilityEndpoint
      utilityUrl
      utilityUrlStatus
      utilityUrlType
      utilityBaseModel
      utilityProvider
      codingEndpoint
      codingUrl
      codingUrlStatus
      codingUrlType
      codingBaseModel
      codingProvider
      generalPurposeEndpoint
      generalPurposeUrl
      generalPurposeUrlStatus
      generalPurposeUrlType
      generalPurposeBaseModel
      generalPurposeProvider
      qaEnpoint
      qaUrl
      qaUrlStatus
      qaUrlType
      qaBaseModel
      qaProvider
      cnEndpoint
      cnUrl
      cnUrlStatus
      cnUrlType
      cnBaseModel
      cnProvider
      gnEnpoint
      gnUrl
      gnUrlStatus
      gnUrlType
      gnBaseModel
      gnProvider
      nlpEnpoint
      nlpUrl
      nlpUrlStatus
      nlpUrlType
      nlpBaseModel
      nlpProvider
      embeddingEndpoint
      embeddingUrl
      embeddingUrlStatus
      embeddingUrlType
      embeddingBaseModel
      embeddingProvider
      chartingEndpoint
      chartingUrl
      chartingUrlStatus
      chartingUrlType
      chartingBaseModel
      chartingProvider
      imagingEndpoint
      imagingUrl
      imagingUrlStatus
      imagingUrlType
      imagingBaseModel
      imagingProvider
      reasoningEndpoint
      reasoningUrl
      reasoningUrlStatus
      reasoningUrlType
      reasoningBaseModel
      reasoningProvider
      billingStatus
      lastBillingDate
      lastConsumptionNotificationDate
      activeUntil
      paymentFailed
      bulkImportAllowed
      lastPaymentAttempt
      targetSubscriptionType
      lastChangeSubscriptionDate
      maxUsers
      baseModel
      domain
      trainingConfig {
        trainingIterations
        trainingIterationsNLP
        trainingIterationsRC
        trainingEpochsNLP
        trainingEpochsRC
        trainingEpochsGN
        maxStepsNLP
        patienceNLP
        learningRateNLP
        learningRateRC
        testSizeNLP
        testSizeRC
        batchSizeNLP
        batchSizeRC
        datasetTestSizeThresholdNLP
        datasetTestSizeThresholdRC
        learningRateGN
        testSizeGN
        batchSizeGN
        datasetTestSizeThresholdGN
        enableManagedSpotTraining
        maxRuntimeWaitTime
        maxRuntime
        includeReadComprehensionDataInTraining
        generateDockerImageForRCengine
        generateDockerImageForNLPengine
        generateDockerImageForGNengine
        emailsListForTrainingConfirmation
        maxQueueWaitTime
      }
      parsingConfig {
        questionsLimit
        answerAsNER
        answerByParagraph
        uniqueAnswer
        isSentenceSplitEnabled
        isImplicitSelfEnabled
        temperature
        maxTokens
        topP
        topK
        qaDocTopK
        frequencyPenalty
        presencePenalty
        qaTopP
        qaTopK
        qaMaxTokens
        qaTemperature
        qaFrequencyPenalty
        qaPresencePenalty
        qaReplyOutsidePassage
        qaAiKnowledge
        qaInhibitionPassage
        qaEnhancementPassage
        qaRole
        qaDefaultAnswer
        qaStopSequence
        stopSequence
        stopPrompt
        qaExamples {
          question
          answer
        }
        qaBlender
        agcEnabled
      }
      notificationConfig {
        emailsList
        emailOnTrainingCompleted
        emailOnBatchCompleted
        emailOnBatchFailed
        emailOnBatchStart
        emailOnTrainingFailed
        emailOnTrainingStart
        notifyAllUsersInWorkspace
        notifyOnThreasholdConsumption
        notificationThresholdConsumption
      }
      embeddingConfig {
        maxChunkWords
        maxOverlapSentences
        chunkingStrategy
        imageExtractionStrategy
        minImageWidth
        minImageHeight
        aspectRatioMin
        aspectRatioMax
      }
      customGenerationConfig {
        styles
        domains
        scopes
        prompts {
          type
          label
          promptLength
          promptPlaceholder
          interpolationString
        }
        hasTopicsContext
        topics
        docTopK
        topK
        blender
        mode
        aiKnowledge
        compressor
      }
      customImageRecognitionModel
      customVectorDB
      workspaceAgents {
        items {
          id
          type
          label
          description
          interpolationString
          emoji
          color
          darkColor
          icon
          largeLogo
          icoUrl
          logoBackground
          darkLogoBackground
          messageOnLaunch
          messagesOnLaunch
          rotateMessagesOnLaunch
          rotateMessagesOnLaunchInterval
          placeholderMessageOnLoading
          customGreetingInstructions
          customConclusionInstructions
          customChartingInstructions
          customSummarisationInstructions
          customImagesInstructions
          customToolingInstructions
          placeholderInputMessage
          openByDefault
          disclaimer
          showDocumentsReferences
          isDefault
          hasMemory
          hasImages
          promptTopKeywords
          keyWordsForKnowledgeBase
          hasTopicsContext
          hasFunctions
          advancedLanguageDetection
          allowedTopics
          staticDocs
          defaultAnswer
          noKnowledgeDefaultAnswer
          quickQuestions
          recencyImportance
          maxRecencyIncrease
          recencyTopKIncreaseFactor
          stopSequence
          enhancementPassage
          inhibitionPassage
          pertinencePassage
          goals
          qaUrl
          topK
          mode
          showCodeInExecution
          hideReasoning
          charting
          summarisation
          compressor
          docTopK
          minRetrievalScore
          timeSignificance
          hasModeration
          customModerations
          moderationMessage
          languageDetectionConfidence
          maxHistory
          maxTokens
          topicEnhancer
          maxTopics
          blender
          temperature
          version
          subject
          workspaceID
          createdBy
          updatedBy
          agentFunctions
          isGlobal
          promptBuffering
          functionContext
          plainTextOutput
          chainOfThoughts
          treeOfThoughts
          extendedOutput
          agentType
          agentsPool
          mcps
          maxPlanningSteps
          virtualDesktopInstructions
          planningInstructions
          plannerExecutionAttempts
          plannerRequiresApprovalForPlanExecution
          plannerEmailOnApprovalRequest
          plannerEmailOnFailedPlan
          plannerEmailOnCompletedPlan
          plannerAutoAgentSpawn
          plannerRetainsSpawnedAgents
          plannerPromptsAgentsProgrammatically
          plannerDeepThinking
          allowReplanning
          plannerProceedsWhenImprovementsRequired
          plannerApproverEmails
          reviewInstructions
          showReferencesToInternalDocs
          preventWidgetUsage
          allowFeedback
          generateExtendedReport
          showTimeForResponse
          showDetectedLanguage
          showRoutedModel
          isMultiLanguageEnabled
          hasMath
          hasCode
          hasComputer
          hasNER
          restrictedAccess
          restrictedAccessUsers
          splashTitle
          showSplashWhenEmpty
          llmEndpoint
          llmUrl
          llmUrlStatus
          llmUrlType
          llmBaseModel
          llmProvider
          forcedTheme
          adverserialProvider
          adverserialModel
          functionCallingProvider
          functionCallingModel
          visionProvider
          visionModel
          videoGenerationProvider
          videoGenerationModel
          showAgentName
          allowImagesUpload
          allowVideosUpload
          allowAudiosUpload
          allowDocsUpload
          allowImagesGeneration
          baseImageGenerationModel
          maxImagesGenerated
          advancedImageGeneration
          allowVideosGeneration
          allowAudiosGeneration
          voiceFileKey
          allowInternetSearch
          bannedDomains
          maxUrlsForInternetSearch
          allowDeepInternetSearch
          internetSearchModes
          internetSearchLocation
          autoVoiceMode
          keywordsWeightInRetrieval
          customCodeExecutionEnvironments
          phoneNumberAsSender
          whatsappNumberAsSender
          emailAsSender
          communicationServices
          channelCallbackDelay
          ephemeralAgent
          parentAgentID
          parentChatID
          minimumSubscriptionType
          clonedAgentID
          clonedAgentIDIcon
          hasContentCreation
          hasEntityExtraction
          department
          metadata
          allowEmailToAgent
          allowedEmails
          agentHiringTemplate
          agentDesktopVM
          agentDesktopPortRange
          agentDesktopCredentials
          agentDesktopBrowser
          allow3dModelGeneration
          agentLongTermMemory
          isLongTermMemoryEnabled
          allowExternalAPI
          forceNewThreadOnProgrammaticRequest
          dynamicModelSelectionInstructions
          contextRelevancyRatio
          reasoningBudget
          reasoningMode
          agentFnParams
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      workspaceCustomPrompts {
        items {
          id
          type
          scope
          style
          domain
          label
          promptLength
          promptPlaceholder
          interpolationString
          availableToAgents
          workspaceID
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      customQaConfig {
        roles {
          type
          label
          description
          interpolationString
          emoji
          color
          isDefault
          hasMemory
          hasTopicsContext
          allowedTopics
          defaultAnswer
          stopSequence
          enhancementPassage
          inhibitionPassage
          pertinencePassage
          goals
          qaUrl
          topK
          mode
          charting
          summarisation
          compressor
          docTopK
          maxHistory
          maxTokens
          topicEnhancer
          maxTopics
          blender
          temperature
          version
          subject
        }
      }
      aiConsumption {
        generator {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        questioner {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        translator {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        answerer {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        parser {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        tokenizer {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        embedder {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        detector {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        chatter {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        planner {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        lastUpdate
        requestsLast30Minutes
        requestsLast24Hours
      }
      disabled
      subscriptionPricingPlan {
        items {
          id
          type
          subscriptionStatus
          isPredictionOnDemandGlobal
          isTrainingOnDemandGlobal
          predictionRequestsGlobal
          batchRequestsGlobal
          trainingMinutesGlobal
          baseModelGN
          baseModelQA
          baseModelNLP
          maxUsers
          agcEnabled
          isDownloadModelEnabled
          isDownloadDataEnabled
          isAPIAccessEnabled
          isBatchJobsEnabled
          isSentimentReviewerEnabled
          isBusinessAnalystEnabled
          isContentCreatorEnabled
          isPriorityTrainingEnabled
          isPredictionGPUAccelerationEnabledGlobal
          isPredictionGPUAccelerationEnabledRC
          isPredictionGPUAccelerationEnabledNLP
          maxMrcDocs
          maxAgents
          maxSites
          maxBenchmarks
          predictionRequestsAPI
          accuracyModelEnabled
          isTrainingNLPEnabled
          isTrainingQAEnabled
          isTrainingGNEnabled
          isLongTermMemoryEnabled
          isFunctionsEnabled
          isDBFunctionsEnabled
          isHtmlFunctionsEnabled
          isSitesBindingEnabled
          isAgentsSecurityEnabled
          isWidgetChatsHistoryEnabled
          maxRequests30Minutes
          maxRequests24Hours
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      folders {
        items {
          id
          owner
          name
          description
          emoji
          status
          parent
          workspaceID
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      trainingLogs {
        items {
          id
          owner
          name
          description
          status
          trainingIterations
          lastActivation
          duration
          trainingMeta
          trainingConfig
          workspaceID
          type
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      entities {
        items {
          id
          owner
          label
          type
          description
          emoji
          parentEntity
          backgroundColor
          workspaceID
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      appLogs {
        items {
          id
          owner
          type
          filename
          event
          status
          workspaceID
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      batchJobs {
        items {
          id
          owner
          name
          description
          status
          duration
          batchMeta
          batchConfig
          batchOutput
          workspaceID
          type
          createdBy
          updatedBy
          benchmarkID
          agentID
          agentVersion
          reviewerAgentID
          reviewerAgentVersion
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      dictionaryItems {
        items {
          id
          owner
          sourceLanguage
          targetLanguage
          sourceText
          targetText
          workspaceID
          pos
          description
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      requestsLogs {
        items {
          id
          srtKey
          type
          status
          words
          tokens
          sentences
          artifactsNumber
          modelType
          outputType
          agentID
          workspaceID
          createdBy
          updatedBy
          creationTime
          isFromToothFairy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      communicationServices {
        items {
          id
          workspaceID
          name
          description
          channel
          provider
          senderid
          fromNumber
          tokenSecret
          isActive
          config
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      sites {
        items {
          id
          name
          description
          url
          workspaceID
          topics
          status
          lastValidationDate
          lastValidationRequested
          validationToken
          allowedPaths
          siteTree
          lastScraped
          skipOwnerValidation
          useProxy
          completion_percentage
          extractImages
          freeRoaming
          scrapingCycle
          imgRetrievalPrompt
          metadata
          createdBy
          updatedBy
          scapablePages
          scrapedPagesCount
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      users
      usersAccessLevel {
        items {
          id
          workspaceID
          userID
          userType
          policyID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      workspaceCreationDate
      workspaceModelReady
      enableDeleteFunctionInAgents
      enableUpdateFunctionInAgents
      enableCustomFunctionInAgents
      defaultChatAgent
      defaultBusinessAnalystAgent
      defaultContentCreatorAgent
      isSentimentReviewerEnabled
      isExtendedContentCreatorEnabled
      isExtendedBusinessAnalystReportEnabled
      customIndexedDBendpoint
      createdBy
      updatedBy
      federationMetadataUrl
      federationMetadataUrlStatus
      federationMetadataUrlType
      ssoType
      ssoDomain
      ssoProviderName
      isMultiLanguageEnabled
      customChartingConfig
      twilioConfig
      emailConfig
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onDeleteWorkspace = /* GraphQL */ `
  subscription OnDeleteWorkspace(
    $filter: ModelSubscriptionWorkspaceFilterInput
  ) {
    onDeleteWorkspace(filter: $filter) {
      id
      owner
      title
      visibility
      userID
      isMed
      type
      usagePlanID
      workspaceTokenID
      workspaceToken
      subscriptionType
      subscriptionId
      subscriptionStatus
      enableExperimentalFeatures
      utilityEndpoint
      utilityUrl
      utilityUrlStatus
      utilityUrlType
      utilityBaseModel
      utilityProvider
      codingEndpoint
      codingUrl
      codingUrlStatus
      codingUrlType
      codingBaseModel
      codingProvider
      generalPurposeEndpoint
      generalPurposeUrl
      generalPurposeUrlStatus
      generalPurposeUrlType
      generalPurposeBaseModel
      generalPurposeProvider
      qaEnpoint
      qaUrl
      qaUrlStatus
      qaUrlType
      qaBaseModel
      qaProvider
      cnEndpoint
      cnUrl
      cnUrlStatus
      cnUrlType
      cnBaseModel
      cnProvider
      gnEnpoint
      gnUrl
      gnUrlStatus
      gnUrlType
      gnBaseModel
      gnProvider
      nlpEnpoint
      nlpUrl
      nlpUrlStatus
      nlpUrlType
      nlpBaseModel
      nlpProvider
      embeddingEndpoint
      embeddingUrl
      embeddingUrlStatus
      embeddingUrlType
      embeddingBaseModel
      embeddingProvider
      chartingEndpoint
      chartingUrl
      chartingUrlStatus
      chartingUrlType
      chartingBaseModel
      chartingProvider
      imagingEndpoint
      imagingUrl
      imagingUrlStatus
      imagingUrlType
      imagingBaseModel
      imagingProvider
      reasoningEndpoint
      reasoningUrl
      reasoningUrlStatus
      reasoningUrlType
      reasoningBaseModel
      reasoningProvider
      billingStatus
      lastBillingDate
      lastConsumptionNotificationDate
      activeUntil
      paymentFailed
      bulkImportAllowed
      lastPaymentAttempt
      targetSubscriptionType
      lastChangeSubscriptionDate
      maxUsers
      baseModel
      domain
      trainingConfig {
        trainingIterations
        trainingIterationsNLP
        trainingIterationsRC
        trainingEpochsNLP
        trainingEpochsRC
        trainingEpochsGN
        maxStepsNLP
        patienceNLP
        learningRateNLP
        learningRateRC
        testSizeNLP
        testSizeRC
        batchSizeNLP
        batchSizeRC
        datasetTestSizeThresholdNLP
        datasetTestSizeThresholdRC
        learningRateGN
        testSizeGN
        batchSizeGN
        datasetTestSizeThresholdGN
        enableManagedSpotTraining
        maxRuntimeWaitTime
        maxRuntime
        includeReadComprehensionDataInTraining
        generateDockerImageForRCengine
        generateDockerImageForNLPengine
        generateDockerImageForGNengine
        emailsListForTrainingConfirmation
        maxQueueWaitTime
      }
      parsingConfig {
        questionsLimit
        answerAsNER
        answerByParagraph
        uniqueAnswer
        isSentenceSplitEnabled
        isImplicitSelfEnabled
        temperature
        maxTokens
        topP
        topK
        qaDocTopK
        frequencyPenalty
        presencePenalty
        qaTopP
        qaTopK
        qaMaxTokens
        qaTemperature
        qaFrequencyPenalty
        qaPresencePenalty
        qaReplyOutsidePassage
        qaAiKnowledge
        qaInhibitionPassage
        qaEnhancementPassage
        qaRole
        qaDefaultAnswer
        qaStopSequence
        stopSequence
        stopPrompt
        qaExamples {
          question
          answer
        }
        qaBlender
        agcEnabled
      }
      notificationConfig {
        emailsList
        emailOnTrainingCompleted
        emailOnBatchCompleted
        emailOnBatchFailed
        emailOnBatchStart
        emailOnTrainingFailed
        emailOnTrainingStart
        notifyAllUsersInWorkspace
        notifyOnThreasholdConsumption
        notificationThresholdConsumption
      }
      embeddingConfig {
        maxChunkWords
        maxOverlapSentences
        chunkingStrategy
        imageExtractionStrategy
        minImageWidth
        minImageHeight
        aspectRatioMin
        aspectRatioMax
      }
      customGenerationConfig {
        styles
        domains
        scopes
        prompts {
          type
          label
          promptLength
          promptPlaceholder
          interpolationString
        }
        hasTopicsContext
        topics
        docTopK
        topK
        blender
        mode
        aiKnowledge
        compressor
      }
      customImageRecognitionModel
      customVectorDB
      workspaceAgents {
        items {
          id
          type
          label
          description
          interpolationString
          emoji
          color
          darkColor
          icon
          largeLogo
          icoUrl
          logoBackground
          darkLogoBackground
          messageOnLaunch
          messagesOnLaunch
          rotateMessagesOnLaunch
          rotateMessagesOnLaunchInterval
          placeholderMessageOnLoading
          customGreetingInstructions
          customConclusionInstructions
          customChartingInstructions
          customSummarisationInstructions
          customImagesInstructions
          customToolingInstructions
          placeholderInputMessage
          openByDefault
          disclaimer
          showDocumentsReferences
          isDefault
          hasMemory
          hasImages
          promptTopKeywords
          keyWordsForKnowledgeBase
          hasTopicsContext
          hasFunctions
          advancedLanguageDetection
          allowedTopics
          staticDocs
          defaultAnswer
          noKnowledgeDefaultAnswer
          quickQuestions
          recencyImportance
          maxRecencyIncrease
          recencyTopKIncreaseFactor
          stopSequence
          enhancementPassage
          inhibitionPassage
          pertinencePassage
          goals
          qaUrl
          topK
          mode
          showCodeInExecution
          hideReasoning
          charting
          summarisation
          compressor
          docTopK
          minRetrievalScore
          timeSignificance
          hasModeration
          customModerations
          moderationMessage
          languageDetectionConfidence
          maxHistory
          maxTokens
          topicEnhancer
          maxTopics
          blender
          temperature
          version
          subject
          workspaceID
          createdBy
          updatedBy
          agentFunctions
          isGlobal
          promptBuffering
          functionContext
          plainTextOutput
          chainOfThoughts
          treeOfThoughts
          extendedOutput
          agentType
          agentsPool
          mcps
          maxPlanningSteps
          virtualDesktopInstructions
          planningInstructions
          plannerExecutionAttempts
          plannerRequiresApprovalForPlanExecution
          plannerEmailOnApprovalRequest
          plannerEmailOnFailedPlan
          plannerEmailOnCompletedPlan
          plannerAutoAgentSpawn
          plannerRetainsSpawnedAgents
          plannerPromptsAgentsProgrammatically
          plannerDeepThinking
          allowReplanning
          plannerProceedsWhenImprovementsRequired
          plannerApproverEmails
          reviewInstructions
          showReferencesToInternalDocs
          preventWidgetUsage
          allowFeedback
          generateExtendedReport
          showTimeForResponse
          showDetectedLanguage
          showRoutedModel
          isMultiLanguageEnabled
          hasMath
          hasCode
          hasComputer
          hasNER
          restrictedAccess
          restrictedAccessUsers
          splashTitle
          showSplashWhenEmpty
          llmEndpoint
          llmUrl
          llmUrlStatus
          llmUrlType
          llmBaseModel
          llmProvider
          forcedTheme
          adverserialProvider
          adverserialModel
          functionCallingProvider
          functionCallingModel
          visionProvider
          visionModel
          videoGenerationProvider
          videoGenerationModel
          showAgentName
          allowImagesUpload
          allowVideosUpload
          allowAudiosUpload
          allowDocsUpload
          allowImagesGeneration
          baseImageGenerationModel
          maxImagesGenerated
          advancedImageGeneration
          allowVideosGeneration
          allowAudiosGeneration
          voiceFileKey
          allowInternetSearch
          bannedDomains
          maxUrlsForInternetSearch
          allowDeepInternetSearch
          internetSearchModes
          internetSearchLocation
          autoVoiceMode
          keywordsWeightInRetrieval
          customCodeExecutionEnvironments
          phoneNumberAsSender
          whatsappNumberAsSender
          emailAsSender
          communicationServices
          channelCallbackDelay
          ephemeralAgent
          parentAgentID
          parentChatID
          minimumSubscriptionType
          clonedAgentID
          clonedAgentIDIcon
          hasContentCreation
          hasEntityExtraction
          department
          metadata
          allowEmailToAgent
          allowedEmails
          agentHiringTemplate
          agentDesktopVM
          agentDesktopPortRange
          agentDesktopCredentials
          agentDesktopBrowser
          allow3dModelGeneration
          agentLongTermMemory
          isLongTermMemoryEnabled
          allowExternalAPI
          forceNewThreadOnProgrammaticRequest
          dynamicModelSelectionInstructions
          contextRelevancyRatio
          reasoningBudget
          reasoningMode
          agentFnParams
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      workspaceCustomPrompts {
        items {
          id
          type
          scope
          style
          domain
          label
          promptLength
          promptPlaceholder
          interpolationString
          availableToAgents
          workspaceID
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      customQaConfig {
        roles {
          type
          label
          description
          interpolationString
          emoji
          color
          isDefault
          hasMemory
          hasTopicsContext
          allowedTopics
          defaultAnswer
          stopSequence
          enhancementPassage
          inhibitionPassage
          pertinencePassage
          goals
          qaUrl
          topK
          mode
          charting
          summarisation
          compressor
          docTopK
          maxHistory
          maxTokens
          topicEnhancer
          maxTopics
          blender
          temperature
          version
          subject
        }
      }
      aiConsumption {
        generator {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        questioner {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        translator {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        answerer {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        parser {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        tokenizer {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        embedder {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        detector {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        chatter {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        planner {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        lastUpdate
        requestsLast30Minutes
        requestsLast24Hours
      }
      disabled
      subscriptionPricingPlan {
        items {
          id
          type
          subscriptionStatus
          isPredictionOnDemandGlobal
          isTrainingOnDemandGlobal
          predictionRequestsGlobal
          batchRequestsGlobal
          trainingMinutesGlobal
          baseModelGN
          baseModelQA
          baseModelNLP
          maxUsers
          agcEnabled
          isDownloadModelEnabled
          isDownloadDataEnabled
          isAPIAccessEnabled
          isBatchJobsEnabled
          isSentimentReviewerEnabled
          isBusinessAnalystEnabled
          isContentCreatorEnabled
          isPriorityTrainingEnabled
          isPredictionGPUAccelerationEnabledGlobal
          isPredictionGPUAccelerationEnabledRC
          isPredictionGPUAccelerationEnabledNLP
          maxMrcDocs
          maxAgents
          maxSites
          maxBenchmarks
          predictionRequestsAPI
          accuracyModelEnabled
          isTrainingNLPEnabled
          isTrainingQAEnabled
          isTrainingGNEnabled
          isLongTermMemoryEnabled
          isFunctionsEnabled
          isDBFunctionsEnabled
          isHtmlFunctionsEnabled
          isSitesBindingEnabled
          isAgentsSecurityEnabled
          isWidgetChatsHistoryEnabled
          maxRequests30Minutes
          maxRequests24Hours
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      folders {
        items {
          id
          owner
          name
          description
          emoji
          status
          parent
          workspaceID
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      trainingLogs {
        items {
          id
          owner
          name
          description
          status
          trainingIterations
          lastActivation
          duration
          trainingMeta
          trainingConfig
          workspaceID
          type
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      entities {
        items {
          id
          owner
          label
          type
          description
          emoji
          parentEntity
          backgroundColor
          workspaceID
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      appLogs {
        items {
          id
          owner
          type
          filename
          event
          status
          workspaceID
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      batchJobs {
        items {
          id
          owner
          name
          description
          status
          duration
          batchMeta
          batchConfig
          batchOutput
          workspaceID
          type
          createdBy
          updatedBy
          benchmarkID
          agentID
          agentVersion
          reviewerAgentID
          reviewerAgentVersion
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      dictionaryItems {
        items {
          id
          owner
          sourceLanguage
          targetLanguage
          sourceText
          targetText
          workspaceID
          pos
          description
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      requestsLogs {
        items {
          id
          srtKey
          type
          status
          words
          tokens
          sentences
          artifactsNumber
          modelType
          outputType
          agentID
          workspaceID
          createdBy
          updatedBy
          creationTime
          isFromToothFairy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      communicationServices {
        items {
          id
          workspaceID
          name
          description
          channel
          provider
          senderid
          fromNumber
          tokenSecret
          isActive
          config
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      sites {
        items {
          id
          name
          description
          url
          workspaceID
          topics
          status
          lastValidationDate
          lastValidationRequested
          validationToken
          allowedPaths
          siteTree
          lastScraped
          skipOwnerValidation
          useProxy
          completion_percentage
          extractImages
          freeRoaming
          scrapingCycle
          imgRetrievalPrompt
          metadata
          createdBy
          updatedBy
          scapablePages
          scrapedPagesCount
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      users
      usersAccessLevel {
        items {
          id
          workspaceID
          userID
          userType
          policyID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      workspaceCreationDate
      workspaceModelReady
      enableDeleteFunctionInAgents
      enableUpdateFunctionInAgents
      enableCustomFunctionInAgents
      defaultChatAgent
      defaultBusinessAnalystAgent
      defaultContentCreatorAgent
      isSentimentReviewerEnabled
      isExtendedContentCreatorEnabled
      isExtendedBusinessAnalystReportEnabled
      customIndexedDBendpoint
      createdBy
      updatedBy
      federationMetadataUrl
      federationMetadataUrlStatus
      federationMetadataUrlType
      ssoType
      ssoDomain
      ssoProviderName
      isMultiLanguageEnabled
      customChartingConfig
      twilioConfig
      emailConfig
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onCreateUserPolicy = /* GraphQL */ `
  subscription OnCreateUserPolicy(
    $filter: ModelSubscriptionUserPolicyFilterInput
  ) {
    onCreateUserPolicy(filter: $filter) {
      id
      workspaceID
      inheritFrom
      properties
      allowedDocs
      allowedModels
      allowedAgents
      createdBy
      createdAt
      creationTime
      updatedAt
      updatedBy
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onUpdateUserPolicy = /* GraphQL */ `
  subscription OnUpdateUserPolicy(
    $filter: ModelSubscriptionUserPolicyFilterInput
  ) {
    onUpdateUserPolicy(filter: $filter) {
      id
      workspaceID
      inheritFrom
      properties
      allowedDocs
      allowedModels
      allowedAgents
      createdBy
      createdAt
      creationTime
      updatedAt
      updatedBy
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onDeleteUserPolicy = /* GraphQL */ `
  subscription OnDeleteUserPolicy(
    $filter: ModelSubscriptionUserPolicyFilterInput
  ) {
    onDeleteUserPolicy(filter: $filter) {
      id
      workspaceID
      inheritFrom
      properties
      allowedDocs
      allowedModels
      allowedAgents
      createdBy
      createdAt
      creationTime
      updatedAt
      updatedBy
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onCreateUserWorkspaceType = /* GraphQL */ `
  subscription OnCreateUserWorkspaceType(
    $filter: ModelSubscriptionUserWorkspaceTypeFilterInput
  ) {
    onCreateUserWorkspaceType(filter: $filter) {
      id
      workspaceID
      userID
      userType
      policyID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onUpdateUserWorkspaceType = /* GraphQL */ `
  subscription OnUpdateUserWorkspaceType(
    $filter: ModelSubscriptionUserWorkspaceTypeFilterInput
  ) {
    onUpdateUserWorkspaceType(filter: $filter) {
      id
      workspaceID
      userID
      userType
      policyID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onDeleteUserWorkspaceType = /* GraphQL */ `
  subscription OnDeleteUserWorkspaceType(
    $filter: ModelSubscriptionUserWorkspaceTypeFilterInput
  ) {
    onDeleteUserWorkspaceType(filter: $filter) {
      id
      workspaceID
      userID
      userType
      policyID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onCreateAgent = /* GraphQL */ `
  subscription OnCreateAgent($filter: ModelSubscriptionAgentFilterInput) {
    onCreateAgent(filter: $filter) {
      id
      type
      label
      description
      interpolationString
      emoji
      color
      darkColor
      icon
      largeLogo
      icoUrl
      logoBackground
      darkLogoBackground
      messageOnLaunch
      messagesOnLaunch
      rotateMessagesOnLaunch
      rotateMessagesOnLaunchInterval
      placeholderMessageOnLoading
      customGreetingInstructions
      customConclusionInstructions
      customChartingInstructions
      customSummarisationInstructions
      customImagesInstructions
      customToolingInstructions
      placeholderInputMessage
      openByDefault
      disclaimer
      showDocumentsReferences
      isDefault
      hasMemory
      hasImages
      promptTopKeywords
      keyWordsForKnowledgeBase
      hasTopicsContext
      hasFunctions
      advancedLanguageDetection
      allowedTopics
      staticDocs
      defaultAnswer
      noKnowledgeDefaultAnswer
      quickQuestions
      recencyImportance
      maxRecencyIncrease
      recencyTopKIncreaseFactor
      stopSequence
      examples {
        question
        answer
      }
      enhancementPassage
      inhibitionPassage
      pertinencePassage
      goals
      qaUrl
      topK
      mode
      showCodeInExecution
      hideReasoning
      charting
      summarisation
      compressor
      docTopK
      minRetrievalScore
      timeSignificance
      hasModeration
      customModerations
      moderationMessage
      languageDetectionConfidence
      maxHistory
      maxTokens
      topicEnhancer
      maxTopics
      blender
      temperature
      version
      subject
      workspaceID
      createdBy
      updatedBy
      agentFunctions
      isGlobal
      promptBuffering
      functionContext
      plainTextOutput
      chainOfThoughts
      treeOfThoughts
      extendedOutput
      agentType
      agentsPool
      mcps
      maxPlanningSteps
      virtualDesktopInstructions
      planningInstructions
      plannerExecutionAttempts
      plannerRequiresApprovalForPlanExecution
      plannerEmailOnApprovalRequest
      plannerEmailOnFailedPlan
      plannerEmailOnCompletedPlan
      plannerAutoAgentSpawn
      plannerRetainsSpawnedAgents
      plannerPromptsAgentsProgrammatically
      plannerDeepThinking
      allowReplanning
      plannerProceedsWhenImprovementsRequired
      plannerApproverEmails
      reviewInstructions
      showReferencesToInternalDocs
      preventWidgetUsage
      allowFeedback
      generateExtendedReport
      showTimeForResponse
      showDetectedLanguage
      showRoutedModel
      isMultiLanguageEnabled
      hasMath
      hasCode
      hasComputer
      hasNER
      restrictedAccess
      restrictedAccessUsers
      splashTitle
      showSplashWhenEmpty
      llmEndpoint
      llmUrl
      llmUrlStatus
      llmUrlType
      llmBaseModel
      llmProvider
      forcedTheme
      adverserialProvider
      adverserialModel
      functionCallingProvider
      functionCallingModel
      visionProvider
      visionModel
      videoGenerationProvider
      videoGenerationModel
      showAgentName
      allowImagesUpload
      allowVideosUpload
      allowAudiosUpload
      allowDocsUpload
      allowImagesGeneration
      baseImageGenerationModel
      maxImagesGenerated
      advancedImageGeneration
      allowVideosGeneration
      allowAudiosGeneration
      voiceFileKey
      allowInternetSearch
      bannedDomains
      maxUrlsForInternetSearch
      allowDeepInternetSearch
      internetSearchModes
      internetSearchLocation
      autoVoiceMode
      keywordsWeightInRetrieval
      customCodeExecutionEnvironments
      phoneNumberAsSender
      whatsappNumberAsSender
      emailAsSender
      communicationServices
      channelCallbackDelay
      ephemeralAgent
      parentAgentID
      parentChatID
      minimumSubscriptionType
      clonedAgentID
      clonedAgentIDIcon
      hasContentCreation
      hasEntityExtraction
      department
      metadata
      allowEmailToAgent
      allowedEmails
      agentHiringTemplate
      agentDesktopVM
      agentDesktopPortRange
      agentDesktopCredentials
      agentDesktopBrowser
      allow3dModelGeneration
      agentLongTermMemory
      isLongTermMemoryEnabled
      allowExternalAPI
      forceNewThreadOnProgrammaticRequest
      dynamicModelSelectionInstructions
      contextRelevancyRatio
      reasoningBudget
      reasoningMode
      agentFnParams
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onUpdateAgent = /* GraphQL */ `
  subscription OnUpdateAgent($filter: ModelSubscriptionAgentFilterInput) {
    onUpdateAgent(filter: $filter) {
      id
      type
      label
      description
      interpolationString
      emoji
      color
      darkColor
      icon
      largeLogo
      icoUrl
      logoBackground
      darkLogoBackground
      messageOnLaunch
      messagesOnLaunch
      rotateMessagesOnLaunch
      rotateMessagesOnLaunchInterval
      placeholderMessageOnLoading
      customGreetingInstructions
      customConclusionInstructions
      customChartingInstructions
      customSummarisationInstructions
      customImagesInstructions
      customToolingInstructions
      placeholderInputMessage
      openByDefault
      disclaimer
      showDocumentsReferences
      isDefault
      hasMemory
      hasImages
      promptTopKeywords
      keyWordsForKnowledgeBase
      hasTopicsContext
      hasFunctions
      advancedLanguageDetection
      allowedTopics
      staticDocs
      defaultAnswer
      noKnowledgeDefaultAnswer
      quickQuestions
      recencyImportance
      maxRecencyIncrease
      recencyTopKIncreaseFactor
      stopSequence
      examples {
        question
        answer
      }
      enhancementPassage
      inhibitionPassage
      pertinencePassage
      goals
      qaUrl
      topK
      mode
      showCodeInExecution
      hideReasoning
      charting
      summarisation
      compressor
      docTopK
      minRetrievalScore
      timeSignificance
      hasModeration
      customModerations
      moderationMessage
      languageDetectionConfidence
      maxHistory
      maxTokens
      topicEnhancer
      maxTopics
      blender
      temperature
      version
      subject
      workspaceID
      createdBy
      updatedBy
      agentFunctions
      isGlobal
      promptBuffering
      functionContext
      plainTextOutput
      chainOfThoughts
      treeOfThoughts
      extendedOutput
      agentType
      agentsPool
      mcps
      maxPlanningSteps
      virtualDesktopInstructions
      planningInstructions
      plannerExecutionAttempts
      plannerRequiresApprovalForPlanExecution
      plannerEmailOnApprovalRequest
      plannerEmailOnFailedPlan
      plannerEmailOnCompletedPlan
      plannerAutoAgentSpawn
      plannerRetainsSpawnedAgents
      plannerPromptsAgentsProgrammatically
      plannerDeepThinking
      allowReplanning
      plannerProceedsWhenImprovementsRequired
      plannerApproverEmails
      reviewInstructions
      showReferencesToInternalDocs
      preventWidgetUsage
      allowFeedback
      generateExtendedReport
      showTimeForResponse
      showDetectedLanguage
      showRoutedModel
      isMultiLanguageEnabled
      hasMath
      hasCode
      hasComputer
      hasNER
      restrictedAccess
      restrictedAccessUsers
      splashTitle
      showSplashWhenEmpty
      llmEndpoint
      llmUrl
      llmUrlStatus
      llmUrlType
      llmBaseModel
      llmProvider
      forcedTheme
      adverserialProvider
      adverserialModel
      functionCallingProvider
      functionCallingModel
      visionProvider
      visionModel
      videoGenerationProvider
      videoGenerationModel
      showAgentName
      allowImagesUpload
      allowVideosUpload
      allowAudiosUpload
      allowDocsUpload
      allowImagesGeneration
      baseImageGenerationModel
      maxImagesGenerated
      advancedImageGeneration
      allowVideosGeneration
      allowAudiosGeneration
      voiceFileKey
      allowInternetSearch
      bannedDomains
      maxUrlsForInternetSearch
      allowDeepInternetSearch
      internetSearchModes
      internetSearchLocation
      autoVoiceMode
      keywordsWeightInRetrieval
      customCodeExecutionEnvironments
      phoneNumberAsSender
      whatsappNumberAsSender
      emailAsSender
      communicationServices
      channelCallbackDelay
      ephemeralAgent
      parentAgentID
      parentChatID
      minimumSubscriptionType
      clonedAgentID
      clonedAgentIDIcon
      hasContentCreation
      hasEntityExtraction
      department
      metadata
      allowEmailToAgent
      allowedEmails
      agentHiringTemplate
      agentDesktopVM
      agentDesktopPortRange
      agentDesktopCredentials
      agentDesktopBrowser
      allow3dModelGeneration
      agentLongTermMemory
      isLongTermMemoryEnabled
      allowExternalAPI
      forceNewThreadOnProgrammaticRequest
      dynamicModelSelectionInstructions
      contextRelevancyRatio
      reasoningBudget
      reasoningMode
      agentFnParams
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onDeleteAgent = /* GraphQL */ `
  subscription OnDeleteAgent($filter: ModelSubscriptionAgentFilterInput) {
    onDeleteAgent(filter: $filter) {
      id
      type
      label
      description
      interpolationString
      emoji
      color
      darkColor
      icon
      largeLogo
      icoUrl
      logoBackground
      darkLogoBackground
      messageOnLaunch
      messagesOnLaunch
      rotateMessagesOnLaunch
      rotateMessagesOnLaunchInterval
      placeholderMessageOnLoading
      customGreetingInstructions
      customConclusionInstructions
      customChartingInstructions
      customSummarisationInstructions
      customImagesInstructions
      customToolingInstructions
      placeholderInputMessage
      openByDefault
      disclaimer
      showDocumentsReferences
      isDefault
      hasMemory
      hasImages
      promptTopKeywords
      keyWordsForKnowledgeBase
      hasTopicsContext
      hasFunctions
      advancedLanguageDetection
      allowedTopics
      staticDocs
      defaultAnswer
      noKnowledgeDefaultAnswer
      quickQuestions
      recencyImportance
      maxRecencyIncrease
      recencyTopKIncreaseFactor
      stopSequence
      examples {
        question
        answer
      }
      enhancementPassage
      inhibitionPassage
      pertinencePassage
      goals
      qaUrl
      topK
      mode
      showCodeInExecution
      hideReasoning
      charting
      summarisation
      compressor
      docTopK
      minRetrievalScore
      timeSignificance
      hasModeration
      customModerations
      moderationMessage
      languageDetectionConfidence
      maxHistory
      maxTokens
      topicEnhancer
      maxTopics
      blender
      temperature
      version
      subject
      workspaceID
      createdBy
      updatedBy
      agentFunctions
      isGlobal
      promptBuffering
      functionContext
      plainTextOutput
      chainOfThoughts
      treeOfThoughts
      extendedOutput
      agentType
      agentsPool
      mcps
      maxPlanningSteps
      virtualDesktopInstructions
      planningInstructions
      plannerExecutionAttempts
      plannerRequiresApprovalForPlanExecution
      plannerEmailOnApprovalRequest
      plannerEmailOnFailedPlan
      plannerEmailOnCompletedPlan
      plannerAutoAgentSpawn
      plannerRetainsSpawnedAgents
      plannerPromptsAgentsProgrammatically
      plannerDeepThinking
      allowReplanning
      plannerProceedsWhenImprovementsRequired
      plannerApproverEmails
      reviewInstructions
      showReferencesToInternalDocs
      preventWidgetUsage
      allowFeedback
      generateExtendedReport
      showTimeForResponse
      showDetectedLanguage
      showRoutedModel
      isMultiLanguageEnabled
      hasMath
      hasCode
      hasComputer
      hasNER
      restrictedAccess
      restrictedAccessUsers
      splashTitle
      showSplashWhenEmpty
      llmEndpoint
      llmUrl
      llmUrlStatus
      llmUrlType
      llmBaseModel
      llmProvider
      forcedTheme
      adverserialProvider
      adverserialModel
      functionCallingProvider
      functionCallingModel
      visionProvider
      visionModel
      videoGenerationProvider
      videoGenerationModel
      showAgentName
      allowImagesUpload
      allowVideosUpload
      allowAudiosUpload
      allowDocsUpload
      allowImagesGeneration
      baseImageGenerationModel
      maxImagesGenerated
      advancedImageGeneration
      allowVideosGeneration
      allowAudiosGeneration
      voiceFileKey
      allowInternetSearch
      bannedDomains
      maxUrlsForInternetSearch
      allowDeepInternetSearch
      internetSearchModes
      internetSearchLocation
      autoVoiceMode
      keywordsWeightInRetrieval
      customCodeExecutionEnvironments
      phoneNumberAsSender
      whatsappNumberAsSender
      emailAsSender
      communicationServices
      channelCallbackDelay
      ephemeralAgent
      parentAgentID
      parentChatID
      minimumSubscriptionType
      clonedAgentID
      clonedAgentIDIcon
      hasContentCreation
      hasEntityExtraction
      department
      metadata
      allowEmailToAgent
      allowedEmails
      agentHiringTemplate
      agentDesktopVM
      agentDesktopPortRange
      agentDesktopCredentials
      agentDesktopBrowser
      allow3dModelGeneration
      agentLongTermMemory
      isLongTermMemoryEnabled
      allowExternalAPI
      forceNewThreadOnProgrammaticRequest
      dynamicModelSelectionInstructions
      contextRelevancyRatio
      reasoningBudget
      reasoningMode
      agentFnParams
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onCreateAgentFunction = /* GraphQL */ `
  subscription OnCreateAgentFunction(
    $filter: ModelSubscriptionAgentFunctionFilterInput
  ) {
    onCreateAgentFunction(filter: $filter) {
      id
      name
      description
      parameters
      model
      url
      requestType
      authorisationType
      dependsOnBeforeExecution
      dependsOnAfterExecution
      authorisationKey
      authorisationID
      paramsAsPath
      scope
      jsonPathExtractor
      headers
      staticArgs
      customExecutionCode
      isCallbackFn
      isDatabaseScript
      isHtmlFn
      isChatFn
      isHandOffFn
      isCodeTemplate
      codeExecutionEnvironmentID
      onFnCall
      handOffAgent
      handOffToOriginalAgentOnCompletion
      handOffToOriginalAgentOnFailure
      handOffAgentOnCompletion
      handOffAgentOnFailure
      chatScript
      chatAction
      htmlUrl
      htmlScript
      isHtmlRedirectFn
      htmlFormOnSuccessfulSubmitMessage
      htmlFormOnFailedSubmitMessage
      dbSchemaMetadata
      preExecutionScript
      postExecutionScript
      dbScript
      dbConnectionID
      preExecutionFnID
      preExecutionMapping
      OAuthConnectionID
      handedOffToHumanOnCall
      usersToHandOffTo
      workspaceID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onUpdateAgentFunction = /* GraphQL */ `
  subscription OnUpdateAgentFunction(
    $filter: ModelSubscriptionAgentFunctionFilterInput
  ) {
    onUpdateAgentFunction(filter: $filter) {
      id
      name
      description
      parameters
      model
      url
      requestType
      authorisationType
      dependsOnBeforeExecution
      dependsOnAfterExecution
      authorisationKey
      authorisationID
      paramsAsPath
      scope
      jsonPathExtractor
      headers
      staticArgs
      customExecutionCode
      isCallbackFn
      isDatabaseScript
      isHtmlFn
      isChatFn
      isHandOffFn
      isCodeTemplate
      codeExecutionEnvironmentID
      onFnCall
      handOffAgent
      handOffToOriginalAgentOnCompletion
      handOffToOriginalAgentOnFailure
      handOffAgentOnCompletion
      handOffAgentOnFailure
      chatScript
      chatAction
      htmlUrl
      htmlScript
      isHtmlRedirectFn
      htmlFormOnSuccessfulSubmitMessage
      htmlFormOnFailedSubmitMessage
      dbSchemaMetadata
      preExecutionScript
      postExecutionScript
      dbScript
      dbConnectionID
      preExecutionFnID
      preExecutionMapping
      OAuthConnectionID
      handedOffToHumanOnCall
      usersToHandOffTo
      workspaceID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onDeleteAgentFunction = /* GraphQL */ `
  subscription OnDeleteAgentFunction(
    $filter: ModelSubscriptionAgentFunctionFilterInput
  ) {
    onDeleteAgentFunction(filter: $filter) {
      id
      name
      description
      parameters
      model
      url
      requestType
      authorisationType
      dependsOnBeforeExecution
      dependsOnAfterExecution
      authorisationKey
      authorisationID
      paramsAsPath
      scope
      jsonPathExtractor
      headers
      staticArgs
      customExecutionCode
      isCallbackFn
      isDatabaseScript
      isHtmlFn
      isChatFn
      isHandOffFn
      isCodeTemplate
      codeExecutionEnvironmentID
      onFnCall
      handOffAgent
      handOffToOriginalAgentOnCompletion
      handOffToOriginalAgentOnFailure
      handOffAgentOnCompletion
      handOffAgentOnFailure
      chatScript
      chatAction
      htmlUrl
      htmlScript
      isHtmlRedirectFn
      htmlFormOnSuccessfulSubmitMessage
      htmlFormOnFailedSubmitMessage
      dbSchemaMetadata
      preExecutionScript
      postExecutionScript
      dbScript
      dbConnectionID
      preExecutionFnID
      preExecutionMapping
      OAuthConnectionID
      handedOffToHumanOnCall
      usersToHandOffTo
      workspaceID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onCreateAuthorisation = /* GraphQL */ `
  subscription OnCreateAuthorisation(
    $filter: ModelSubscriptionAuthorisationFilterInput
  ) {
    onCreateAuthorisation(filter: $filter) {
      id
      name
      tokenSecret
      description
      scope
      grantType
      clientId
      clientSecret
      authorizationBaseUrl
      staticArgs
      tokenBaseUrl
      type
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onUpdateAuthorisation = /* GraphQL */ `
  subscription OnUpdateAuthorisation(
    $filter: ModelSubscriptionAuthorisationFilterInput
  ) {
    onUpdateAuthorisation(filter: $filter) {
      id
      name
      tokenSecret
      description
      scope
      grantType
      clientId
      clientSecret
      authorizationBaseUrl
      staticArgs
      tokenBaseUrl
      type
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onDeleteAuthorisation = /* GraphQL */ `
  subscription OnDeleteAuthorisation(
    $filter: ModelSubscriptionAuthorisationFilterInput
  ) {
    onDeleteAuthorisation(filter: $filter) {
      id
      name
      tokenSecret
      description
      scope
      grantType
      clientId
      clientSecret
      authorizationBaseUrl
      staticArgs
      tokenBaseUrl
      type
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onCreateHosting = /* GraphQL */ `
  subscription OnCreateHosting($filter: ModelSubscriptionHostingFilterInput) {
    onCreateHosting(filter: $filter) {
      id
      name
      description
      tokenSecret
      endpoint
      modelName
      baseModel
      customModel
      apiVersion
      type
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onUpdateHosting = /* GraphQL */ `
  subscription OnUpdateHosting($filter: ModelSubscriptionHostingFilterInput) {
    onUpdateHosting(filter: $filter) {
      id
      name
      description
      tokenSecret
      endpoint
      modelName
      baseModel
      customModel
      apiVersion
      type
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onDeleteHosting = /* GraphQL */ `
  subscription OnDeleteHosting($filter: ModelSubscriptionHostingFilterInput) {
    onDeleteHosting(filter: $filter) {
      id
      name
      description
      tokenSecret
      endpoint
      modelName
      baseModel
      customModel
      apiVersion
      type
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onCreateMCP = /* GraphQL */ `
  subscription OnCreateMCP($filter: ModelSubscriptionMCPFilterInput) {
    onCreateMCP(filter: $filter) {
      id
      name
      version
      description
      tokenSecret
      endpoint
      toolsAvailable
      resourcesAvailable
      promptsAvailable
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onUpdateMCP = /* GraphQL */ `
  subscription OnUpdateMCP($filter: ModelSubscriptionMCPFilterInput) {
    onUpdateMCP(filter: $filter) {
      id
      name
      version
      description
      tokenSecret
      endpoint
      toolsAvailable
      resourcesAvailable
      promptsAvailable
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onDeleteMCP = /* GraphQL */ `
  subscription OnDeleteMCP($filter: ModelSubscriptionMCPFilterInput) {
    onDeleteMCP(filter: $filter) {
      id
      name
      version
      description
      tokenSecret
      endpoint
      toolsAvailable
      resourcesAvailable
      promptsAvailable
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onCreateDatabaseConnection = /* GraphQL */ `
  subscription OnCreateDatabaseConnection(
    $filter: ModelSubscriptionDatabaseConnectionFilterInput
  ) {
    onCreateDatabaseConnection(filter: $filter) {
      id
      name
      description
      type
      host
      port
      username
      passwordSecret
      database
      schema
      ssl
      ssh
      sshHost
      sshPort
      sshUsername
      sshPasswordSecret
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onUpdateDatabaseConnection = /* GraphQL */ `
  subscription OnUpdateDatabaseConnection(
    $filter: ModelSubscriptionDatabaseConnectionFilterInput
  ) {
    onUpdateDatabaseConnection(filter: $filter) {
      id
      name
      description
      type
      host
      port
      username
      passwordSecret
      database
      schema
      ssl
      ssh
      sshHost
      sshPort
      sshUsername
      sshPasswordSecret
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onDeleteDatabaseConnection = /* GraphQL */ `
  subscription OnDeleteDatabaseConnection(
    $filter: ModelSubscriptionDatabaseConnectionFilterInput
  ) {
    onDeleteDatabaseConnection(filter: $filter) {
      id
      name
      description
      type
      host
      port
      username
      passwordSecret
      database
      schema
      ssl
      ssh
      sshHost
      sshPort
      sshUsername
      sshPasswordSecret
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onCreateUserNotification = /* GraphQL */ `
  subscription OnCreateUserNotification(
    $filter: ModelSubscriptionUserNotificationFilterInput
  ) {
    onCreateUserNotification(filter: $filter) {
      id
      type
      title
      description
      userID
      metadata
      createdBy
      updatedBy
      workspaceID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onUpdateUserNotification = /* GraphQL */ `
  subscription OnUpdateUserNotification(
    $filter: ModelSubscriptionUserNotificationFilterInput
  ) {
    onUpdateUserNotification(filter: $filter) {
      id
      type
      title
      description
      userID
      metadata
      createdBy
      updatedBy
      workspaceID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onDeleteUserNotification = /* GraphQL */ `
  subscription OnDeleteUserNotification(
    $filter: ModelSubscriptionUserNotificationFilterInput
  ) {
    onDeleteUserNotification(filter: $filter) {
      id
      type
      title
      description
      userID
      metadata
      createdBy
      updatedBy
      workspaceID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onCreateVirtualMachine = /* GraphQL */ `
  subscription OnCreateVirtualMachine(
    $filter: ModelSubscriptionVirtualMachineFilterInput
  ) {
    onCreateVirtualMachine(filter: $filter) {
      id
      name
      description
      ip
      workspaceID
      port
      metadata
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onUpdateVirtualMachine = /* GraphQL */ `
  subscription OnUpdateVirtualMachine(
    $filter: ModelSubscriptionVirtualMachineFilterInput
  ) {
    onUpdateVirtualMachine(filter: $filter) {
      id
      name
      description
      ip
      workspaceID
      port
      metadata
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onDeleteVirtualMachine = /* GraphQL */ `
  subscription OnDeleteVirtualMachine(
    $filter: ModelSubscriptionVirtualMachineFilterInput
  ) {
    onDeleteVirtualMachine(filter: $filter) {
      id
      name
      description
      ip
      workspaceID
      port
      metadata
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onCreateSite = /* GraphQL */ `
  subscription OnCreateSite($filter: ModelSubscriptionSiteFilterInput) {
    onCreateSite(filter: $filter) {
      id
      name
      description
      url
      workspaceID
      topics
      status
      lastValidationDate
      lastValidationRequested
      validationToken
      allowedPaths
      siteTree
      lastScraped
      skipOwnerValidation
      useProxy
      completion_percentage
      extractImages
      freeRoaming
      scrapingCycle
      imgRetrievalPrompt
      metadata
      createdBy
      updatedBy
      scapablePages
      scrapedPagesCount
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onUpdateSite = /* GraphQL */ `
  subscription OnUpdateSite($filter: ModelSubscriptionSiteFilterInput) {
    onUpdateSite(filter: $filter) {
      id
      name
      description
      url
      workspaceID
      topics
      status
      lastValidationDate
      lastValidationRequested
      validationToken
      allowedPaths
      siteTree
      lastScraped
      skipOwnerValidation
      useProxy
      completion_percentage
      extractImages
      freeRoaming
      scrapingCycle
      imgRetrievalPrompt
      metadata
      createdBy
      updatedBy
      scapablePages
      scrapedPagesCount
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onDeleteSite = /* GraphQL */ `
  subscription OnDeleteSite($filter: ModelSubscriptionSiteFilterInput) {
    onDeleteSite(filter: $filter) {
      id
      name
      description
      url
      workspaceID
      topics
      status
      lastValidationDate
      lastValidationRequested
      validationToken
      allowedPaths
      siteTree
      lastScraped
      skipOwnerValidation
      useProxy
      completion_percentage
      extractImages
      freeRoaming
      scrapingCycle
      imgRetrievalPrompt
      metadata
      createdBy
      updatedBy
      scapablePages
      scrapedPagesCount
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onCreateEntityAI = /* GraphQL */ `
  subscription OnCreateEntityAI($filter: ModelSubscriptionEntityAIFilterInput) {
    onCreateEntityAI(filter: $filter) {
      id
      owner
      label
      type
      description
      emoji
      parentEntity
      backgroundColor
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onUpdateEntityAI = /* GraphQL */ `
  subscription OnUpdateEntityAI($filter: ModelSubscriptionEntityAIFilterInput) {
    onUpdateEntityAI(filter: $filter) {
      id
      owner
      label
      type
      description
      emoji
      parentEntity
      backgroundColor
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onDeleteEntityAI = /* GraphQL */ `
  subscription OnDeleteEntityAI($filter: ModelSubscriptionEntityAIFilterInput) {
    onDeleteEntityAI(filter: $filter) {
      id
      owner
      label
      type
      description
      emoji
      parentEntity
      backgroundColor
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onCreateTrainingLog = /* GraphQL */ `
  subscription OnCreateTrainingLog(
    $filter: ModelSubscriptionTrainingLogFilterInput
  ) {
    onCreateTrainingLog(filter: $filter) {
      id
      owner
      name
      description
      status
      trainingIterations
      lastActivation
      duration
      trainingMeta
      trainingConfig
      workspaceID
      type
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onUpdateTrainingLog = /* GraphQL */ `
  subscription OnUpdateTrainingLog(
    $filter: ModelSubscriptionTrainingLogFilterInput
  ) {
    onUpdateTrainingLog(filter: $filter) {
      id
      owner
      name
      description
      status
      trainingIterations
      lastActivation
      duration
      trainingMeta
      trainingConfig
      workspaceID
      type
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onDeleteTrainingLog = /* GraphQL */ `
  subscription OnDeleteTrainingLog(
    $filter: ModelSubscriptionTrainingLogFilterInput
  ) {
    onDeleteTrainingLog(filter: $filter) {
      id
      owner
      name
      description
      status
      trainingIterations
      lastActivation
      duration
      trainingMeta
      trainingConfig
      workspaceID
      type
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onCreateBatchJobLog = /* GraphQL */ `
  subscription OnCreateBatchJobLog(
    $filter: ModelSubscriptionBatchJobLogFilterInput
  ) {
    onCreateBatchJobLog(filter: $filter) {
      id
      owner
      name
      description
      status
      duration
      batchMeta
      batchConfig
      batchOutput
      workspaceID
      type
      createdBy
      updatedBy
      benchmarkID
      agentID
      agentVersion
      reviewerAgentID
      reviewerAgentVersion
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onUpdateBatchJobLog = /* GraphQL */ `
  subscription OnUpdateBatchJobLog(
    $filter: ModelSubscriptionBatchJobLogFilterInput
  ) {
    onUpdateBatchJobLog(filter: $filter) {
      id
      owner
      name
      description
      status
      duration
      batchMeta
      batchConfig
      batchOutput
      workspaceID
      type
      createdBy
      updatedBy
      benchmarkID
      agentID
      agentVersion
      reviewerAgentID
      reviewerAgentVersion
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onDeleteBatchJobLog = /* GraphQL */ `
  subscription OnDeleteBatchJobLog(
    $filter: ModelSubscriptionBatchJobLogFilterInput
  ) {
    onDeleteBatchJobLog(filter: $filter) {
      id
      owner
      name
      description
      status
      duration
      batchMeta
      batchConfig
      batchOutput
      workspaceID
      type
      createdBy
      updatedBy
      benchmarkID
      agentID
      agentVersion
      reviewerAgentID
      reviewerAgentVersion
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onCreateAppLog = /* GraphQL */ `
  subscription OnCreateAppLog($filter: ModelSubscriptionAppLogFilterInput) {
    onCreateAppLog(filter: $filter) {
      id
      owner
      type
      filename
      event
      status
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onUpdateAppLog = /* GraphQL */ `
  subscription OnUpdateAppLog($filter: ModelSubscriptionAppLogFilterInput) {
    onUpdateAppLog(filter: $filter) {
      id
      owner
      type
      filename
      event
      status
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onDeleteAppLog = /* GraphQL */ `
  subscription OnDeleteAppLog($filter: ModelSubscriptionAppLogFilterInput) {
    onDeleteAppLog(filter: $filter) {
      id
      owner
      type
      filename
      event
      status
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onCreateRequestLog = /* GraphQL */ `
  subscription OnCreateRequestLog(
    $filter: ModelSubscriptionRequestLogFilterInput
  ) {
    onCreateRequestLog(filter: $filter) {
      id
      srtKey
      type
      status
      words
      tokens
      sentences
      artifactsNumber
      modelType
      outputType
      agentID
      workspaceID
      createdBy
      updatedBy
      creationTime
      isFromToothFairy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onUpdateRequestLog = /* GraphQL */ `
  subscription OnUpdateRequestLog(
    $filter: ModelSubscriptionRequestLogFilterInput
  ) {
    onUpdateRequestLog(filter: $filter) {
      id
      srtKey
      type
      status
      words
      tokens
      sentences
      artifactsNumber
      modelType
      outputType
      agentID
      workspaceID
      createdBy
      updatedBy
      creationTime
      isFromToothFairy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onDeleteRequestLog = /* GraphQL */ `
  subscription OnDeleteRequestLog(
    $filter: ModelSubscriptionRequestLogFilterInput
  ) {
    onDeleteRequestLog(filter: $filter) {
      id
      srtKey
      type
      status
      words
      tokens
      sentences
      artifactsNumber
      modelType
      outputType
      agentID
      workspaceID
      createdBy
      updatedBy
      creationTime
      isFromToothFairy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onCreateOutputStream = /* GraphQL */ `
  subscription OnCreateOutputStream(
    $filter: ModelSubscriptionOutputStreamFilterInput
  ) {
    onCreateOutputStream(filter: $filter) {
      id
      content
      t_content
      prompt
      t_prompt
      workspaceID
      type
      status
      humanFeedback
      humanFeedbackComment
      humanFeedbackType
      humanFeedbackSubType
      humanFeedbackProvidedBy
      adminResolution
      adminChecked
      autoTune
      scoring
      metadata
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onUpdateOutputStream = /* GraphQL */ `
  subscription OnUpdateOutputStream(
    $filter: ModelSubscriptionOutputStreamFilterInput
  ) {
    onUpdateOutputStream(filter: $filter) {
      id
      content
      t_content
      prompt
      t_prompt
      workspaceID
      type
      status
      humanFeedback
      humanFeedbackComment
      humanFeedbackType
      humanFeedbackSubType
      humanFeedbackProvidedBy
      adminResolution
      adminChecked
      autoTune
      scoring
      metadata
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onDeleteOutputStream = /* GraphQL */ `
  subscription OnDeleteOutputStream(
    $filter: ModelSubscriptionOutputStreamFilterInput
  ) {
    onDeleteOutputStream(filter: $filter) {
      id
      content
      t_content
      prompt
      t_prompt
      workspaceID
      type
      status
      humanFeedback
      humanFeedbackComment
      humanFeedbackType
      humanFeedbackSubType
      humanFeedbackProvidedBy
      adminResolution
      adminChecked
      autoTune
      scoring
      metadata
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onCreateFolders = /* GraphQL */ `
  subscription OnCreateFolders($filter: ModelSubscriptionFoldersFilterInput) {
    onCreateFolders(filter: $filter) {
      id
      owner
      name
      description
      emoji
      status
      parent
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onUpdateFolders = /* GraphQL */ `
  subscription OnUpdateFolders($filter: ModelSubscriptionFoldersFilterInput) {
    onUpdateFolders(filter: $filter) {
      id
      owner
      name
      description
      emoji
      status
      parent
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onDeleteFolders = /* GraphQL */ `
  subscription OnDeleteFolders($filter: ModelSubscriptionFoldersFilterInput) {
    onDeleteFolders(filter: $filter) {
      id
      owner
      name
      description
      emoji
      status
      parent
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onCreateDictionaryItem = /* GraphQL */ `
  subscription OnCreateDictionaryItem(
    $filter: ModelSubscriptionDictionaryItemFilterInput
  ) {
    onCreateDictionaryItem(filter: $filter) {
      id
      owner
      sourceLanguage
      targetLanguage
      sourceText
      targetText
      workspaceID
      pos
      description
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onUpdateDictionaryItem = /* GraphQL */ `
  subscription OnUpdateDictionaryItem(
    $filter: ModelSubscriptionDictionaryItemFilterInput
  ) {
    onUpdateDictionaryItem(filter: $filter) {
      id
      owner
      sourceLanguage
      targetLanguage
      sourceText
      targetText
      workspaceID
      pos
      description
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onDeleteDictionaryItem = /* GraphQL */ `
  subscription OnDeleteDictionaryItem(
    $filter: ModelSubscriptionDictionaryItemFilterInput
  ) {
    onDeleteDictionaryItem(filter: $filter) {
      id
      owner
      sourceLanguage
      targetLanguage
      sourceText
      targetText
      workspaceID
      pos
      description
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onCreateChat = /* GraphQL */ `
  subscription OnCreateChat($filter: ModelSubscriptionChatFilterInput) {
    onCreateChat(filter: $filter) {
      id
      owner
      name
      description
      status {
        status
        lastUpdated
      }
      workspaceID
      creationTime
      createdBy
      updatedBy
      visibility
      isAIReplying
      activeMessageForAI
      messages {
        items {
          id
          role
          chatID
          text
          t_text
          t_text_summary
          createdAt
          creationTime
          updatedAt
          scoring
          embeddingId
          humanFeedback
          humanFeedbackComment
          humanFeedbackType
          humanFeedbackSubType
          humanFeedbackProvidedBy
          adminResolution
          prevMessage
          prevMessagePosEq
          prevMessageNegEq
          correctContext
          correctAnswer
          adminChecked
          autoTune
          userID
          agentID
          humanFeedbackForInstruction
          images
          audios
          videos
          files
          imagesText
          audiosText
          videosText
          filesText
          isAI
          messageType
          status
          metadata
          callbackMetadata
          workspaceID
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      chatHistory
      topics
      documentId
      primaryRole
      primaryAgent
      plannerAgent
      forcePlannerStop
      allowMultipleRoles
      handedOffToHuman
      roles
      language
      summary
      caseId
      customerId
      caseInfo
      customerInfo
      projectId
      projectInfo
      genericEntityId
      genericEntityInfo
      metadata
      userFeedbackOnSteps
      channelSettings
      externalParticipantId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onUpdateChat = /* GraphQL */ `
  subscription OnUpdateChat($filter: ModelSubscriptionChatFilterInput) {
    onUpdateChat(filter: $filter) {
      id
      owner
      name
      description
      status {
        status
        lastUpdated
      }
      workspaceID
      creationTime
      createdBy
      updatedBy
      visibility
      isAIReplying
      activeMessageForAI
      messages {
        items {
          id
          role
          chatID
          text
          t_text
          t_text_summary
          createdAt
          creationTime
          updatedAt
          scoring
          embeddingId
          humanFeedback
          humanFeedbackComment
          humanFeedbackType
          humanFeedbackSubType
          humanFeedbackProvidedBy
          adminResolution
          prevMessage
          prevMessagePosEq
          prevMessageNegEq
          correctContext
          correctAnswer
          adminChecked
          autoTune
          userID
          agentID
          humanFeedbackForInstruction
          images
          audios
          videos
          files
          imagesText
          audiosText
          videosText
          filesText
          isAI
          messageType
          status
          metadata
          callbackMetadata
          workspaceID
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      chatHistory
      topics
      documentId
      primaryRole
      primaryAgent
      plannerAgent
      forcePlannerStop
      allowMultipleRoles
      handedOffToHuman
      roles
      language
      summary
      caseId
      customerId
      caseInfo
      customerInfo
      projectId
      projectInfo
      genericEntityId
      genericEntityInfo
      metadata
      userFeedbackOnSteps
      channelSettings
      externalParticipantId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onDeleteChat = /* GraphQL */ `
  subscription OnDeleteChat($filter: ModelSubscriptionChatFilterInput) {
    onDeleteChat(filter: $filter) {
      id
      owner
      name
      description
      status {
        status
        lastUpdated
      }
      workspaceID
      creationTime
      createdBy
      updatedBy
      visibility
      isAIReplying
      activeMessageForAI
      messages {
        items {
          id
          role
          chatID
          text
          t_text
          t_text_summary
          createdAt
          creationTime
          updatedAt
          scoring
          embeddingId
          humanFeedback
          humanFeedbackComment
          humanFeedbackType
          humanFeedbackSubType
          humanFeedbackProvidedBy
          adminResolution
          prevMessage
          prevMessagePosEq
          prevMessageNegEq
          correctContext
          correctAnswer
          adminChecked
          autoTune
          userID
          agentID
          humanFeedbackForInstruction
          images
          audios
          videos
          files
          imagesText
          audiosText
          videosText
          filesText
          isAI
          messageType
          status
          metadata
          callbackMetadata
          workspaceID
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      chatHistory
      topics
      documentId
      primaryRole
      primaryAgent
      plannerAgent
      forcePlannerStop
      allowMultipleRoles
      handedOffToHuman
      roles
      language
      summary
      caseId
      customerId
      caseInfo
      customerInfo
      projectId
      projectInfo
      genericEntityId
      genericEntityInfo
      metadata
      userFeedbackOnSteps
      channelSettings
      externalParticipantId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onCreateCustomPrompt = /* GraphQL */ `
  subscription OnCreateCustomPrompt(
    $filter: ModelSubscriptionCustomPromptFilterInput
  ) {
    onCreateCustomPrompt(filter: $filter) {
      id
      type
      scope
      style
      domain
      label
      promptLength
      promptPlaceholder
      interpolationString
      availableToAgents
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onUpdateCustomPrompt = /* GraphQL */ `
  subscription OnUpdateCustomPrompt(
    $filter: ModelSubscriptionCustomPromptFilterInput
  ) {
    onUpdateCustomPrompt(filter: $filter) {
      id
      type
      scope
      style
      domain
      label
      promptLength
      promptPlaceholder
      interpolationString
      availableToAgents
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onDeleteCustomPrompt = /* GraphQL */ `
  subscription OnDeleteCustomPrompt(
    $filter: ModelSubscriptionCustomPromptFilterInput
  ) {
    onDeleteCustomPrompt(filter: $filter) {
      id
      type
      scope
      style
      domain
      label
      promptLength
      promptPlaceholder
      interpolationString
      availableToAgents
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onCreateCustomCodeExecutionEnvironment = /* GraphQL */ `
  subscription OnCreateCustomCodeExecutionEnvironment(
    $filter: ModelSubscriptionCustomCodeExecutionEnvironmentFilterInput
  ) {
    onCreateCustomCodeExecutionEnvironment(filter: $filter) {
      id
      name
      description
      functionName
      availableLibraries
      customExecutionInstructions
      customExecutionCode
      customExecutionSecrets
      allowExternalAPI
      hardcodedScript
      isTemplate
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onUpdateCustomCodeExecutionEnvironment = /* GraphQL */ `
  subscription OnUpdateCustomCodeExecutionEnvironment(
    $filter: ModelSubscriptionCustomCodeExecutionEnvironmentFilterInput
  ) {
    onUpdateCustomCodeExecutionEnvironment(filter: $filter) {
      id
      name
      description
      functionName
      availableLibraries
      customExecutionInstructions
      customExecutionCode
      customExecutionSecrets
      allowExternalAPI
      hardcodedScript
      isTemplate
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onDeleteCustomCodeExecutionEnvironment = /* GraphQL */ `
  subscription OnDeleteCustomCodeExecutionEnvironment(
    $filter: ModelSubscriptionCustomCodeExecutionEnvironmentFilterInput
  ) {
    onDeleteCustomCodeExecutionEnvironment(filter: $filter) {
      id
      name
      description
      functionName
      availableLibraries
      customExecutionInstructions
      customExecutionCode
      customExecutionSecrets
      allowExternalAPI
      hardcodedScript
      isTemplate
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onCreateChatMessage = /* GraphQL */ `
  subscription OnCreateChatMessage(
    $filter: ModelSubscriptionChatMessageFilterInput
  ) {
    onCreateChatMessage(filter: $filter) {
      id
      role
      chatID
      text
      t_text
      t_text_summary
      createdAt
      creationTime
      updatedAt
      scoring
      embeddingId
      humanFeedback
      humanFeedbackComment
      humanFeedbackType
      humanFeedbackSubType
      humanFeedbackProvidedBy
      adminResolution
      prevMessage
      prevMessagePosEq
      prevMessageNegEq
      correctContext
      correctAnswer
      adminChecked
      autoTune
      userID
      agentID
      humanFeedbackForInstruction
      images
      audios
      videos
      files
      imagesText
      audiosText
      videosText
      filesText
      isAI
      messageType
      status
      metadata
      callbackMetadata
      workspaceID
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onUpdateChatMessage = /* GraphQL */ `
  subscription OnUpdateChatMessage(
    $filter: ModelSubscriptionChatMessageFilterInput
  ) {
    onUpdateChatMessage(filter: $filter) {
      id
      role
      chatID
      text
      t_text
      t_text_summary
      createdAt
      creationTime
      updatedAt
      scoring
      embeddingId
      humanFeedback
      humanFeedbackComment
      humanFeedbackType
      humanFeedbackSubType
      humanFeedbackProvidedBy
      adminResolution
      prevMessage
      prevMessagePosEq
      prevMessageNegEq
      correctContext
      correctAnswer
      adminChecked
      autoTune
      userID
      agentID
      humanFeedbackForInstruction
      images
      audios
      videos
      files
      imagesText
      audiosText
      videosText
      filesText
      isAI
      messageType
      status
      metadata
      callbackMetadata
      workspaceID
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onDeleteChatMessage = /* GraphQL */ `
  subscription OnDeleteChatMessage(
    $filter: ModelSubscriptionChatMessageFilterInput
  ) {
    onDeleteChatMessage(filter: $filter) {
      id
      role
      chatID
      text
      t_text
      t_text_summary
      createdAt
      creationTime
      updatedAt
      scoring
      embeddingId
      humanFeedback
      humanFeedbackComment
      humanFeedbackType
      humanFeedbackSubType
      humanFeedbackProvidedBy
      adminResolution
      prevMessage
      prevMessagePosEq
      prevMessageNegEq
      correctContext
      correctAnswer
      adminChecked
      autoTune
      userID
      agentID
      humanFeedbackForInstruction
      images
      audios
      videos
      files
      imagesText
      audiosText
      videosText
      filesText
      isAI
      messageType
      status
      metadata
      callbackMetadata
      workspaceID
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onCreateCommunicationService = /* GraphQL */ `
  subscription OnCreateCommunicationService(
    $filter: ModelSubscriptionCommunicationServiceFilterInput
  ) {
    onCreateCommunicationService(filter: $filter) {
      id
      workspaceID
      name
      description
      channel
      provider
      senderid
      fromNumber
      tokenSecret
      isActive
      config
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onUpdateCommunicationService = /* GraphQL */ `
  subscription OnUpdateCommunicationService(
    $filter: ModelSubscriptionCommunicationServiceFilterInput
  ) {
    onUpdateCommunicationService(filter: $filter) {
      id
      workspaceID
      name
      description
      channel
      provider
      senderid
      fromNumber
      tokenSecret
      isActive
      config
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onDeleteCommunicationService = /* GraphQL */ `
  subscription OnDeleteCommunicationService(
    $filter: ModelSubscriptionCommunicationServiceFilterInput
  ) {
    onDeleteCommunicationService(filter: $filter) {
      id
      workspaceID
      name
      description
      channel
      provider
      senderid
      fromNumber
      tokenSecret
      isActive
      config
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onCreateSubscriptionPricingPlan = /* GraphQL */ `
  subscription OnCreateSubscriptionPricingPlan(
    $filter: ModelSubscriptionSubscriptionPricingPlanFilterInput
  ) {
    onCreateSubscriptionPricingPlan(filter: $filter) {
      id
      type
      subscriptionStatus
      isPredictionOnDemandGlobal
      isTrainingOnDemandGlobal
      predictionRequestsGlobal
      batchRequestsGlobal
      trainingMinutesGlobal
      baseModelGN
      baseModelQA
      baseModelNLP
      maxUsers
      agcEnabled
      isDownloadModelEnabled
      isDownloadDataEnabled
      isAPIAccessEnabled
      isBatchJobsEnabled
      isSentimentReviewerEnabled
      isBusinessAnalystEnabled
      isContentCreatorEnabled
      isPriorityTrainingEnabled
      isPredictionGPUAccelerationEnabledGlobal
      isPredictionGPUAccelerationEnabledRC
      isPredictionGPUAccelerationEnabledNLP
      aiMaxConsumption {
        generator {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        questioner {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        translator {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        answerer {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        parser {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        tokenizer {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        embedder {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        detector {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        chatter {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        planner {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        lastUpdate
        requestsLast30Minutes
        requestsLast24Hours
      }
      maxMrcDocs
      maxAgents
      maxSites
      maxBenchmarks
      predictionRequestsAPI
      accuracyModelEnabled
      isTrainingNLPEnabled
      isTrainingQAEnabled
      isTrainingGNEnabled
      isLongTermMemoryEnabled
      isFunctionsEnabled
      isDBFunctionsEnabled
      isHtmlFunctionsEnabled
      isSitesBindingEnabled
      isAgentsSecurityEnabled
      isWidgetChatsHistoryEnabled
      maxRequests30Minutes
      maxRequests24Hours
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onUpdateSubscriptionPricingPlan = /* GraphQL */ `
  subscription OnUpdateSubscriptionPricingPlan(
    $filter: ModelSubscriptionSubscriptionPricingPlanFilterInput
  ) {
    onUpdateSubscriptionPricingPlan(filter: $filter) {
      id
      type
      subscriptionStatus
      isPredictionOnDemandGlobal
      isTrainingOnDemandGlobal
      predictionRequestsGlobal
      batchRequestsGlobal
      trainingMinutesGlobal
      baseModelGN
      baseModelQA
      baseModelNLP
      maxUsers
      agcEnabled
      isDownloadModelEnabled
      isDownloadDataEnabled
      isAPIAccessEnabled
      isBatchJobsEnabled
      isSentimentReviewerEnabled
      isBusinessAnalystEnabled
      isContentCreatorEnabled
      isPriorityTrainingEnabled
      isPredictionGPUAccelerationEnabledGlobal
      isPredictionGPUAccelerationEnabledRC
      isPredictionGPUAccelerationEnabledNLP
      aiMaxConsumption {
        generator {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        questioner {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        translator {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        answerer {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        parser {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        tokenizer {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        embedder {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        detector {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        chatter {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        planner {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        lastUpdate
        requestsLast30Minutes
        requestsLast24Hours
      }
      maxMrcDocs
      maxAgents
      maxSites
      maxBenchmarks
      predictionRequestsAPI
      accuracyModelEnabled
      isTrainingNLPEnabled
      isTrainingQAEnabled
      isTrainingGNEnabled
      isLongTermMemoryEnabled
      isFunctionsEnabled
      isDBFunctionsEnabled
      isHtmlFunctionsEnabled
      isSitesBindingEnabled
      isAgentsSecurityEnabled
      isWidgetChatsHistoryEnabled
      maxRequests30Minutes
      maxRequests24Hours
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onDeleteSubscriptionPricingPlan = /* GraphQL */ `
  subscription OnDeleteSubscriptionPricingPlan(
    $filter: ModelSubscriptionSubscriptionPricingPlanFilterInput
  ) {
    onDeleteSubscriptionPricingPlan(filter: $filter) {
      id
      type
      subscriptionStatus
      isPredictionOnDemandGlobal
      isTrainingOnDemandGlobal
      predictionRequestsGlobal
      batchRequestsGlobal
      trainingMinutesGlobal
      baseModelGN
      baseModelQA
      baseModelNLP
      maxUsers
      agcEnabled
      isDownloadModelEnabled
      isDownloadDataEnabled
      isAPIAccessEnabled
      isBatchJobsEnabled
      isSentimentReviewerEnabled
      isBusinessAnalystEnabled
      isContentCreatorEnabled
      isPriorityTrainingEnabled
      isPredictionGPUAccelerationEnabledGlobal
      isPredictionGPUAccelerationEnabledRC
      isPredictionGPUAccelerationEnabledNLP
      aiMaxConsumption {
        generator {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        questioner {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        translator {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        answerer {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        parser {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        tokenizer {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        embedder {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        detector {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        chatter {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        planner {
          requests
          words
          tokens
          sentences
          apiRequests
        }
        lastUpdate
        requestsLast30Minutes
        requestsLast24Hours
      }
      maxMrcDocs
      maxAgents
      maxSites
      maxBenchmarks
      predictionRequestsAPI
      accuracyModelEnabled
      isTrainingNLPEnabled
      isTrainingQAEnabled
      isTrainingGNEnabled
      isLongTermMemoryEnabled
      isFunctionsEnabled
      isDBFunctionsEnabled
      isHtmlFunctionsEnabled
      isSitesBindingEnabled
      isAgentsSecurityEnabled
      isWidgetChatsHistoryEnabled
      maxRequests30Minutes
      maxRequests24Hours
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onCreateSubscriptionBaseConfig = /* GraphQL */ `
  subscription OnCreateSubscriptionBaseConfig(
    $filter: ModelSubscriptionSubscriptionBaseConfigFilterInput
  ) {
    onCreateSubscriptionBaseConfig(filter: $filter) {
      id
      type
      planConfig {
        domain
        parsingConfig {
          questionsLimit
          answerAsNER
          answerByParagraph
          uniqueAnswer
          isSentenceSplitEnabled
          isImplicitSelfEnabled
          temperature
          maxTokens
          topP
          topK
          qaDocTopK
          frequencyPenalty
          presencePenalty
          qaTopP
          qaTopK
          qaMaxTokens
          qaTemperature
          qaFrequencyPenalty
          qaPresencePenalty
          qaReplyOutsidePassage
          qaAiKnowledge
          qaInhibitionPassage
          qaEnhancementPassage
          qaRole
          qaDefaultAnswer
          qaStopSequence
          stopSequence
          stopPrompt
          qaBlender
          agcEnabled
        }
        notificationConfig {
          emailsList
          emailOnTrainingCompleted
          emailOnBatchCompleted
          emailOnBatchFailed
          emailOnBatchStart
          emailOnTrainingFailed
          emailOnTrainingStart
          notifyAllUsersInWorkspace
          notifyOnThreasholdConsumption
          notificationThresholdConsumption
        }
        trainingConfig {
          trainingIterations
          trainingIterationsNLP
          trainingIterationsRC
          trainingEpochsNLP
          trainingEpochsRC
          trainingEpochsGN
          maxStepsNLP
          patienceNLP
          learningRateNLP
          learningRateRC
          testSizeNLP
          testSizeRC
          batchSizeNLP
          batchSizeRC
          datasetTestSizeThresholdNLP
          datasetTestSizeThresholdRC
          learningRateGN
          testSizeGN
          batchSizeGN
          datasetTestSizeThresholdGN
          enableManagedSpotTraining
          maxRuntimeWaitTime
          maxRuntime
          includeReadComprehensionDataInTraining
          generateDockerImageForRCengine
          generateDockerImageForNLPengine
          generateDockerImageForGNengine
          emailsListForTrainingConfirmation
          maxQueueWaitTime
        }
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onUpdateSubscriptionBaseConfig = /* GraphQL */ `
  subscription OnUpdateSubscriptionBaseConfig(
    $filter: ModelSubscriptionSubscriptionBaseConfigFilterInput
  ) {
    onUpdateSubscriptionBaseConfig(filter: $filter) {
      id
      type
      planConfig {
        domain
        parsingConfig {
          questionsLimit
          answerAsNER
          answerByParagraph
          uniqueAnswer
          isSentenceSplitEnabled
          isImplicitSelfEnabled
          temperature
          maxTokens
          topP
          topK
          qaDocTopK
          frequencyPenalty
          presencePenalty
          qaTopP
          qaTopK
          qaMaxTokens
          qaTemperature
          qaFrequencyPenalty
          qaPresencePenalty
          qaReplyOutsidePassage
          qaAiKnowledge
          qaInhibitionPassage
          qaEnhancementPassage
          qaRole
          qaDefaultAnswer
          qaStopSequence
          stopSequence
          stopPrompt
          qaBlender
          agcEnabled
        }
        notificationConfig {
          emailsList
          emailOnTrainingCompleted
          emailOnBatchCompleted
          emailOnBatchFailed
          emailOnBatchStart
          emailOnTrainingFailed
          emailOnTrainingStart
          notifyAllUsersInWorkspace
          notifyOnThreasholdConsumption
          notificationThresholdConsumption
        }
        trainingConfig {
          trainingIterations
          trainingIterationsNLP
          trainingIterationsRC
          trainingEpochsNLP
          trainingEpochsRC
          trainingEpochsGN
          maxStepsNLP
          patienceNLP
          learningRateNLP
          learningRateRC
          testSizeNLP
          testSizeRC
          batchSizeNLP
          batchSizeRC
          datasetTestSizeThresholdNLP
          datasetTestSizeThresholdRC
          learningRateGN
          testSizeGN
          batchSizeGN
          datasetTestSizeThresholdGN
          enableManagedSpotTraining
          maxRuntimeWaitTime
          maxRuntime
          includeReadComprehensionDataInTraining
          generateDockerImageForRCengine
          generateDockerImageForNLPengine
          generateDockerImageForGNengine
          emailsListForTrainingConfirmation
          maxQueueWaitTime
        }
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onDeleteSubscriptionBaseConfig = /* GraphQL */ `
  subscription OnDeleteSubscriptionBaseConfig(
    $filter: ModelSubscriptionSubscriptionBaseConfigFilterInput
  ) {
    onDeleteSubscriptionBaseConfig(filter: $filter) {
      id
      type
      planConfig {
        domain
        parsingConfig {
          questionsLimit
          answerAsNER
          answerByParagraph
          uniqueAnswer
          isSentenceSplitEnabled
          isImplicitSelfEnabled
          temperature
          maxTokens
          topP
          topK
          qaDocTopK
          frequencyPenalty
          presencePenalty
          qaTopP
          qaTopK
          qaMaxTokens
          qaTemperature
          qaFrequencyPenalty
          qaPresencePenalty
          qaReplyOutsidePassage
          qaAiKnowledge
          qaInhibitionPassage
          qaEnhancementPassage
          qaRole
          qaDefaultAnswer
          qaStopSequence
          stopSequence
          stopPrompt
          qaBlender
          agcEnabled
        }
        notificationConfig {
          emailsList
          emailOnTrainingCompleted
          emailOnBatchCompleted
          emailOnBatchFailed
          emailOnBatchStart
          emailOnTrainingFailed
          emailOnTrainingStart
          notifyAllUsersInWorkspace
          notifyOnThreasholdConsumption
          notificationThresholdConsumption
        }
        trainingConfig {
          trainingIterations
          trainingIterationsNLP
          trainingIterationsRC
          trainingEpochsNLP
          trainingEpochsRC
          trainingEpochsGN
          maxStepsNLP
          patienceNLP
          learningRateNLP
          learningRateRC
          testSizeNLP
          testSizeRC
          batchSizeNLP
          batchSizeRC
          datasetTestSizeThresholdNLP
          datasetTestSizeThresholdRC
          learningRateGN
          testSizeGN
          batchSizeGN
          datasetTestSizeThresholdGN
          enableManagedSpotTraining
          maxRuntimeWaitTime
          maxRuntime
          includeReadComprehensionDataInTraining
          generateDockerImageForRCengine
          generateDockerImageForNLPengine
          generateDockerImageForGNengine
          emailsListForTrainingConfirmation
          maxQueueWaitTime
        }
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onCreateGenerationConfig = /* GraphQL */ `
  subscription OnCreateGenerationConfig(
    $filter: ModelSubscriptionGenerationConfigFilterInput
  ) {
    onCreateGenerationConfig(filter: $filter) {
      id
      styles
      domains
      scopes
      prompts {
        type
        label
        promptLength
        promptPlaceholder
        interpolationString
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onUpdateGenerationConfig = /* GraphQL */ `
  subscription OnUpdateGenerationConfig(
    $filter: ModelSubscriptionGenerationConfigFilterInput
  ) {
    onUpdateGenerationConfig(filter: $filter) {
      id
      styles
      domains
      scopes
      prompts {
        type
        label
        promptLength
        promptPlaceholder
        interpolationString
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onDeleteGenerationConfig = /* GraphQL */ `
  subscription OnDeleteGenerationConfig(
    $filter: ModelSubscriptionGenerationConfigFilterInput
  ) {
    onDeleteGenerationConfig(filter: $filter) {
      id
      styles
      domains
      scopes
      prompts {
        type
        label
        promptLength
        promptPlaceholder
        interpolationString
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onCreateArenaBattle = /* GraphQL */ `
  subscription OnCreateArenaBattle(
    $filter: ModelSubscriptionArenaBattleFilterInput
  ) {
    onCreateArenaBattle(filter: $filter) {
      id
      firstAgent
      secondAgent
      firstAgentChatID
      secondAgentChatID
      winnerID
      createdAt
      creationTime
      updatedAt
      workspaceID
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onUpdateArenaBattle = /* GraphQL */ `
  subscription OnUpdateArenaBattle(
    $filter: ModelSubscriptionArenaBattleFilterInput
  ) {
    onUpdateArenaBattle(filter: $filter) {
      id
      firstAgent
      secondAgent
      firstAgentChatID
      secondAgentChatID
      winnerID
      createdAt
      creationTime
      updatedAt
      workspaceID
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onDeleteArenaBattle = /* GraphQL */ `
  subscription OnDeleteArenaBattle(
    $filter: ModelSubscriptionArenaBattleFilterInput
  ) {
    onDeleteArenaBattle(filter: $filter) {
      id
      firstAgent
      secondAgent
      firstAgentChatID
      secondAgentChatID
      winnerID
      createdAt
      creationTime
      updatedAt
      workspaceID
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onCreateBenchmark = /* GraphQL */ `
  subscription OnCreateBenchmark(
    $filter: ModelSubscriptionBenchmarkFilterInput
  ) {
    onCreateBenchmark(filter: $filter) {
      id
      name
      description
      questions {
        type
        question
        answer
        reasoning
        context
        images
        files
      }
      workspaceID
      createdAt
      creationTime
      updatedAt
      metadata
      files
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onUpdateBenchmark = /* GraphQL */ `
  subscription OnUpdateBenchmark(
    $filter: ModelSubscriptionBenchmarkFilterInput
  ) {
    onUpdateBenchmark(filter: $filter) {
      id
      name
      description
      questions {
        type
        question
        answer
        reasoning
        context
        images
        files
      }
      workspaceID
      createdAt
      creationTime
      updatedAt
      metadata
      files
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onDeleteBenchmark = /* GraphQL */ `
  subscription OnDeleteBenchmark(
    $filter: ModelSubscriptionBenchmarkFilterInput
  ) {
    onDeleteBenchmark(filter: $filter) {
      id
      name
      description
      questions {
        type
        question
        answer
        reasoning
        context
        images
        files
      }
      workspaceID
      createdAt
      creationTime
      updatedAt
      metadata
      files
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onCreateProject = /* GraphQL */ `
  subscription OnCreateProject($filter: ModelSubscriptionProjectFilterInput) {
    onCreateProject(filter: $filter) {
      id
      name
      description
      startDate
      endDate
      status
      workspaceID
      agentID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onUpdateProject = /* GraphQL */ `
  subscription OnUpdateProject($filter: ModelSubscriptionProjectFilterInput) {
    onUpdateProject(filter: $filter) {
      id
      name
      description
      startDate
      endDate
      status
      workspaceID
      agentID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onDeleteProject = /* GraphQL */ `
  subscription OnDeleteProject($filter: ModelSubscriptionProjectFilterInput) {
    onDeleteProject(filter: $filter) {
      id
      name
      description
      startDate
      endDate
      status
      workspaceID
      agentID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onCreateReminder = /* GraphQL */ `
  subscription OnCreateReminder($filter: ModelSubscriptionReminderFilterInput) {
    onCreateReminder(filter: $filter) {
      id
      title
      description
      workspaceID
      projectID
      status
      priority
      dueDate
      completedDate
      recurringPattern
      assignedTo
      metadata
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onUpdateReminder = /* GraphQL */ `
  subscription OnUpdateReminder($filter: ModelSubscriptionReminderFilterInput) {
    onUpdateReminder(filter: $filter) {
      id
      title
      description
      workspaceID
      projectID
      status
      priority
      dueDate
      completedDate
      recurringPattern
      assignedTo
      metadata
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onDeleteReminder = /* GraphQL */ `
  subscription OnDeleteReminder($filter: ModelSubscriptionReminderFilterInput) {
    onDeleteReminder(filter: $filter) {
      id
      title
      description
      workspaceID
      projectID
      status
      priority
      dueDate
      completedDate
      recurringPattern
      assignedTo
      metadata
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onCreateProjectItem = /* GraphQL */ `
  subscription OnCreateProjectItem(
    $filter: ModelSubscriptionProjectItemFilterInput
  ) {
    onCreateProjectItem(filter: $filter) {
      id
      title
      description
      type
      status
      priority
      dueDate
      assignee
      metadata
      projectID
      workspaceID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onUpdateProjectItem = /* GraphQL */ `
  subscription OnUpdateProjectItem(
    $filter: ModelSubscriptionProjectItemFilterInput
  ) {
    onUpdateProjectItem(filter: $filter) {
      id
      title
      description
      type
      status
      priority
      dueDate
      assignee
      metadata
      projectID
      workspaceID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onDeleteProjectItem = /* GraphQL */ `
  subscription OnDeleteProjectItem(
    $filter: ModelSubscriptionProjectItemFilterInput
  ) {
    onDeleteProjectItem(filter: $filter) {
      id
      title
      description
      type
      status
      priority
      dueDate
      assignee
      metadata
      projectID
      workspaceID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onCreateCustomer = /* GraphQL */ `
  subscription OnCreateCustomer($filter: ModelSubscriptionCustomerFilterInput) {
    onCreateCustomer(filter: $filter) {
      id
      name
      companyName
      email
      phone
      type
      status
      lifecycle
      segment
      pipeline
      lastContactDate
      nextFollowUpDate
      assignedTo
      totalRevenue
      potentialValue
      currency
      acquisitionSource
      relationshipStrength
      metadata
      notes
      createdAt
      updatedAt
      workspaceID
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onUpdateCustomer = /* GraphQL */ `
  subscription OnUpdateCustomer($filter: ModelSubscriptionCustomerFilterInput) {
    onUpdateCustomer(filter: $filter) {
      id
      name
      companyName
      email
      phone
      type
      status
      lifecycle
      segment
      pipeline
      lastContactDate
      nextFollowUpDate
      assignedTo
      totalRevenue
      potentialValue
      currency
      acquisitionSource
      relationshipStrength
      metadata
      notes
      createdAt
      updatedAt
      workspaceID
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onDeleteCustomer = /* GraphQL */ `
  subscription OnDeleteCustomer($filter: ModelSubscriptionCustomerFilterInput) {
    onDeleteCustomer(filter: $filter) {
      id
      name
      companyName
      email
      phone
      type
      status
      lifecycle
      segment
      pipeline
      lastContactDate
      nextFollowUpDate
      assignedTo
      totalRevenue
      potentialValue
      currency
      acquisitionSource
      relationshipStrength
      metadata
      notes
      createdAt
      updatedAt
      workspaceID
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onCreateLog = /* GraphQL */ `
  subscription OnCreateLog($filter: ModelSubscriptionLogFilterInput) {
    onCreateLog(filter: $filter) {
      id
      type
      action
      description
      metadata
      performedBy
      performedAt
      workspaceID
      projectItem
      customerItem
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onUpdateLog = /* GraphQL */ `
  subscription OnUpdateLog($filter: ModelSubscriptionLogFilterInput) {
    onUpdateLog(filter: $filter) {
      id
      type
      action
      description
      metadata
      performedBy
      performedAt
      workspaceID
      projectItem
      customerItem
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const onDeleteLog = /* GraphQL */ `
  subscription OnDeleteLog($filter: ModelSubscriptionLogFilterInput) {
    onDeleteLog(filter: $filter) {
      id
      type
      action
      description
      metadata
      performedBy
      performedAt
      workspaceID
      projectItem
      customerItem
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
